<template>
  <!-- 勤務表 親コンポーネント -->
  <div id="roster">
    <CCard class="roster-card">
      <div v-if="!fromExternal">
        <CCardHeader>
          <h2>勤務表</h2>
        </CCardHeader>
        <CCardBody>
          <!--
            **枠を中身の幅に合わせる。**共通の検索パネルは全幅だが、
            この画面は条件が「年月」だけなので、右3分の2が空の罫線に
            なって間延びして見えた（テスターの「左側に寄せすぎている」）。
            他の画面は条件が多いので、共通側は触らない。
          -->
          <table class="table search-table roster-search-table">
            <tr>
              <th style="width: 100px">年月</th>
              <th style="width: 75px"></th>
              <th style="width: 50px"></th>
              <th></th>
            </tr>
            <tr>
              <td>
                <select
                  class="custom-select preika-control--year"
                  v-model="year"
                 
                >
                  <option
                    v-for="option in yearOption"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td>
                <select
                  class="custom-select preika-control--month"
                  v-model="month"
                 
                >
                  <option
                    v-for="option in monthOption"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </td>
              <td>業務分</td>
              <td>
                <save-button
                  :label="'表示'"
                  :loading="loading"
                  :disabled="globalLoading"
                  @click="callList"
                  />
              </td>
            </tr>
          </table>
        </CCardBody>
      </div>
      <template v-if="displayFlg">
        <div v-if="!fromExternal">
          <div class="roster-guide-grid">
            <CCard color="info" class="roster-guide-card text-white">
              <CCardHeader class="roster-guide-card__header">
                <strong>入力手順</strong>
              </CCardHeader>
              <CCardBody class="roster-guide-card__body">
                1.開始時刻、終了時刻、休憩、夜勤休憩に実績を入力<br/>
                （定時は候補表示です。過去日は「定時を反映」、当日はダッシュボード打刻を利用できます）<br/>
                2.勤怠1を選択<br/>
                <!-- 区分の名前は rosterAttendanceKinds.js の表から出す。選択肢と説明がずれないように。 -->
                勤怠1が{{ guideNames.opensAttendance2 }}の場合は勤怠2（午後側）も選択<br/>
                勤怠1が{{ guideNames.clearsTimes }}の場合、時間欄は選択時に自動で空欄になります<br/>
                休日に出勤した日は、勤怠1で{{ guideNames.holiday }}を選択してから時刻と休憩を入力してください。<br/>
                <a href="#" class="paid-rule-link" @click.prevent="openAttendanceHelp('1')">勤怠1の説明</a> /
                <a href="#" class="paid-rule-link" @click.prevent="openAttendanceHelp('2')">勤怠2の説明</a><br/>
                3.備考・作業内容を入力し、入力内容に不備がなければ「保存」ボタンを押下<br/>
              </CCardBody>
            </CCard>
            <!-- 取込も見出しの月（保存する月）で判定する。選択欄の月を渡すと、別の月のファイルが
                 表示中の月の行へ入り、表示中の月の実績として保存される。 -->
            <RosterFileImport
              :year="selectYear"
              :month="selectMonth"
              :month-day="monthDay"
              :start="start"
              :end="end"
              :rest="rest"
              :rest-as-blank="importRestAsBlank"
              :night-rest="nightRest"
              :night-rest-as-blank="importNightRestAsBlank"
              :attendance1="attendance1"
              :attendance2="attendance2"
              :remarks="remarks"
              :project-id="projectId"
              :project-options="projectOptions"
              :disabled="globalLoading || statusBtn"
              @apply="applyRosterFileImport"
            />
          </div>
        </div>
        <CCardHeader>
          <strong
            v-if="showYearMonth"
            style="font-size: 20px; font-weight: bold"
          >
            {{ selectYear }} 年 {{ selectMonth }} 月
            <span style="margin-left: 10px"></span>
            <span :style="statusColor(status[0])">【{{ getStatusLabel(status[0]) }}】</span>
          </strong>
        </CCardHeader>
        <CCardBody>
          <ValidationObserver ref="obs">
            <td v-if="errors.length">
              <div class="preika-form-message" v-for="error in errors" :key="error">
                {{ error }}
              </div>
            </td>
            <form
              class="edit-form"
              name="edit"
              action="/change"
              method="post"
              @submit.prevent="edit"
            >
              <div class="edit-form__group">
                <!--
                  **ボタンは説明のすぐ下・左。**

                  以前は flex の space-between で右端に離していた。
                  画面が広いほど離れるので、説明を読み終わった視線の先に
                  無い。2026-09-01、気づかない人が複数いたと報告があった。

                  「過去日の空欄は明示操作で定時を反映できます」と
                  書いてある、その直後に押すものが来る形にする。
                -->
                <!--
                  **保存できない勤務表では出さない。**管理者用と承認待ち・承認済みの月は
                  欄を読み取り専用で描くので、「定時を反映できます」も押すボタンも嘘になる。
                -->
                <div v-if="!readOnly" class="roster-actual-guide">
                  <strong>定時は候補、時刻欄は実績です</strong>
                  <p>未来日は候補だけを表示し、当日はダッシュボード打刻を優先します。過去日の空欄は明示操作で定時を反映できます。</p>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm roster-actual-guide__action"
                    :disabled="globalLoading || statusBtn"
                    @click="applyDefaultsToPast"
                  >
                    経過済みの空欄へ定時を反映
                  </button>
                </div>
                <!--
                  入力区分（その日の開始・終了時刻が、打刻か、勤務表での入力・修正か）。
                  会社に打刻の記録が1件も無いうちは出さない。本人にも、承認者・管理者にも同じものを出す。
                -->
                <div v-if="stampOriginAvailable" class="roster-stamp-legend" data-testid="roster-stamp-legend">
                  <p v-if="stampSummaryText" class="roster-stamp-summary" data-testid="roster-stamp-summary"
                    :class="{ 'roster-stamp-summary--entered': stampRosterEnteredIndexes.length > 0 }"
                  >{{ stampSummaryText }}</p>
                  <ul>
                    <li><strong>入力区分</strong></li>
                    <li><span class="roster-stamp-mark roster-stamp-mark--STAMP" aria-hidden="true"></span>打刻</li>
                    <li><span class="roster-stamp-mark roster-stamp-mark--EDITED" aria-hidden="true"></span>打刻後修正</li>
                    <li><span class="roster-stamp-mark roster-stamp-mark--ROSTER" aria-hidden="true"></span>手入力</li>
                  </ul>
                  <small>※手入力または修正した時刻のセルは、背景を濃く表示しています。</small>
                  <small>※機能の提供開始前の日付にはアイコンを表示していません。</small>
                </div>
                <CRow style="padding: 0px">
                  <div
                    ref="rosterTableScroll"
                    class="table-responsive roster-table-scroll"
                    @scroll="onRosterTableScroll"
                  >
                    <table class="table table-bordered" style="width: 100%">
                      <thead>
                        <tr>
                          <th class="dayHeader"
                            style="
                              font-size: 12px;
                              width: 80px;
                              padding-bottom: 15px;
                            "
                          >
                            日付<br/>&nbsp;曜日
                          </th>
                          <th style="width: 120px">開始時刻</th>
                          <th style="width: 120px">終了時刻</th>
                          <!--
                            **列の名前を先に、時間帯を後に。**開始時刻・終了時刻は
                            名前だけなので、時間帯が上にあると休憩の2列だけ頭が
                            ずれて見える。何の列かを先に読ませる。
                          -->
                          <th style="width: 120px">休憩<br/><span class="preika-th-note">5:00～22:00</span></th>
                          <th style="width: 120px">夜勤休憩<br/><span class="preika-th-note">22:00～5:00</span></th>
                          <th style="width: 120px">
                            勤怠1
                            <a
                              href="#"
                              class="help-icon help-icon-inline"
                              @click.prevent="openAttendance1Help"
                              aria-label="勤怠1の説明を表示"
                            >
                              ?
                            </a>
                          </th>
                          <th style="width: 120px">
                            勤怠2
                            <a
                              href="#"
                              class="help-icon help-icon-inline"
                              @click.prevent="openAttendance2Help"
                              aria-label="勤怠2の説明を表示"
                            >
                              ?
                            </a>
                          </th>
                          <th style="width: 300px">備考・業務内容</th>
                          <!--
                            **列の名前が先、道具は後。**ほかの列は名前だけ
                            なので、ここだけ一括変更の欄が先に来ていると、
                            見出しの行を横に読んだときにこの列だけ名前が
                            見つからない（テスターの指摘）。
                          -->
                          <th style="width: 150px">
                            プロジェクト名
                            <select
                              v-if="!readOnly"
                              class="custom-select preika-control--reference"

                              v-model="bulkProjectId"
                              @change="applyBulkProject"
                              :disabled="globalLoading"
                            >
                              <option disabled value="">【一括変更】</option>
                              <option
                                v-for="opt in projectOptions"
                                :key="opt.id"
                                :value="opt.id"
                              >
                                {{ opt.name }}<template v-if="opt.external">（現在所属外）</template>
                              </option>
                            </select>
                          </th>
                          <th style="width: 80px">業務</th>
                          <th style="width: 80px">時間外</th>
                          <th style="width: 80px">夜勤<br/></th>
                          <th style="width: 80px">法定休日</th>
                          <th style="width: 80px">控除</th>
                        </tr>
                        <!-- <input type="hidden" :value="setDay"> -->
                        <!-- <input type="hidden" :value="holiday"> -->
                        <input type="hidden" :value="endSetting" />
                      </thead>
                      <tbody
                        v-for="(day, index) in monthDay"
                        :key="index"
                        :class="getDayClass(day,attendance1[index])"
                      >
                        <tr>
                          <td style="width: 5%">
                            <label class="dayLabel">{{ monthDay[index].replace(' (', '\n(') }}</label>
                            <button
                              v-if="stampOriginAt(index)"
                              type="button"
                              class="roster-stamp-button"
                              :data-testid="'roster-stamp-origin-' + (index + 1)"
                              :data-origin="stampOriginAt(index).origin"
                              :title="stampOriginLabelAt(index)"
                              :aria-label="(index + 1) + '日の入力区分：' + stampOriginLabelAt(index)"
                              :aria-expanded="stampOpenIndex === index ? 'true' : 'false'"
                              @click="toggleStampHistory(index)"
                            >
                              <span class="roster-stamp-mark" :class="'roster-stamp-mark--' + stampOriginAt(index).origin" aria-hidden="true"></span>
                              <span class="roster-stamp-button__label">{{ stampOriginLabelAt(index) }}</span>
                            </button>
                            <span v-if="isFutureIndex(index)" class="roster-row-state">予定</span>
                            <button
                              v-else-if="!readOnly && canApplyDefaultAt(index)"
                              type="button"
                              class="roster-default-button"
                              :disabled="globalLoading"
                              @click="applyDefaultAt(index)"
                            >定時を反映</button>
                          </td>
                          <td style="width: 0%" :class="{ 'roster-cell--by-roster': stampStartByRosterAt(index) }">
                            <ValidationProvider
                              :name="[index + 1] + '日の開始時刻'"
                              rules=""
                              v-slot="provider"
                            >
                              <CInput class="preika-control-frame--time"
                                style="margin-bottom: 3px"
                                type="time"
                                maxlength="5"
                                v-model="start[index]"
                                :placeholder="schedulePlaceholder(showsCandidate(index) ? startBasic[index] : '')"
                                :disabled="readOnly || isFutureIndex(index) || globalLoading"
                                :tabindex="[index] + 1"
                                @change="autoRestTime(index)"
                              />
                              <!--
                                **場所は常に取る。**v-if で消すと、入力した瞬間に
                                その欄だけ高さが縮んで行の中でずれる。候補が無い列
                                （休憩）とも揃わない。中身だけを出し分ける。
                              -->
                              <small class="roster-time-candidate">
                                <template v-if="showsCandidate(index) && !start[index] && startBasic[index]"
                                  >候補 {{ startBasic[index] }}</template>
                              </small>
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                          </td>
                          <td style="width: 0%" :class="{ 'roster-cell--by-roster': stampEndByRosterAt(index) }">
                            <ValidationProvider
                              :name="[index + 1] + '日の終了時刻'"
                              rules=""
                              v-slot="provider"
                            >
                              <CInput class="preika-control-frame--time"
                                style="margin-bottom: 3px"
                                type="time"
                                maxlength="5"
                                v-model="end[index]"
                                :placeholder="schedulePlaceholder(showsCandidate(index) ? endBasic[index] : '')"
                                :disabled="readOnly || isFutureIndex(index) || globalLoading"
                                :tabindex="[index] + 2"
                                @change="autoRestTime(index)"
                              />
                              <small class="roster-time-candidate">
                                <template v-if="showsCandidate(index) && !end[index] && endBasic[index]"
                                  >候補 {{ endBasic[index] }}</template>
                              </small>
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                          </td>
                          <td style="width: 0%">
                            <RestInput
                              :rest="rest[index]"
                              :index="index"
                              :post-buffer="postBuffer[index]"
                              :breakBasic="breakBasic[index]"
                              :flg="postWorkBreakFlg[index]"
                              :blank-day="!showsCandidate(index) && !start[index] && !end[index]"
                              :actual-end="end[index]"
                              :end-basic="endBasic[index]"
                              :tabindex="index + 3"
                              :label="(index + 1) + '日の休憩'"
                              :disabled="readOnly || isFutureIndex(index) || globalLoading"
                              :placeholder="schedulePlaceholder(showsCandidate(index) ? breakBasic[index] : '')"
                              :manual="isRestManual(index)"
                              @update-rest="onUpdateRest"
                            />
                          </td>
                          <td style="width: 0%">
                            <ValidationProvider
                              :name="[index + 1] + '日の夜勤休憩'"
                              rules=""
                              v-slot="provider"
                            >
                              <CInput class="preika-control-frame--time"
                                style="margin-bottom: 3px"
                                type="time"
                                maxlength="5"
                                v-model="nightRest[index]"
                                :placeholder="showsCandidate(index) ? '候補 00:00' : schedulePlaceholder('')"
                                :disabled="readOnly || isFutureIndex(index) || globalLoading"
                                :tabindex="[index] + 4"
                                @change="onNightRestChange(index)"
                              />
                              <small class="roster-time-candidate">
                                <template v-if="showsCandidate(index) && !nightRest[index]"
                                  >候補 00:00</template>
                              </small>
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                          </td>
                          <td>
                            <ValidationProvider
                              :name="[index + 1] + '日の勤怠1'"
                              rules="select"
                              v-slot="provider"
                            >
                              <select
                                style="margin-bottom: 3px"
                                class="custom-select preika-control--choice"
                                v-model="attendance1[index]"
                                :disabled="readOnly || globalLoading"
                                :tabindex="[index] + 4"
                                @change="onAttendance1Change(index)"
                              >
                                <option value></option>
                                <option
                                  v-for="option in visibleOptionsAt(index)"
                                  :value="option.id"
                                  :key="option.id"
                                >
                                  {{ option.name }}
                                </option>
                              </select>
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                          </td>
                          <td>
                            <!--
                              **必須かどうかは、この行の勤怠1で決める**（attendance2Required）。

                              以前は必須の条件が1つの値で全部の行に掛かっていて、その値が月の最後の日の
                              勤怠1だけで決まっていた。最後の日が午前系・早出の月は、勤怠2を選べない行
                              （常勤・休日）まで必須になり、その月を保存できなかった。2026-10-02 に、
                              保存できない月を無くすため、いったん必須を外した（月の途中の午前系の行は、
                              もともと勤怠2が空でも保存できていた）。

                              ここで、行ごとの必須を入れる。掛かるのは午前の区分と早出出勤の行だけなので、
                              勤怠2を選べない行には掛からない。前に保存した行を、勤怠1を変えずに保存し直す
                              ときは求めない（午前有給で勤怠2が空のまま保存された行が、本番にある）。
                              back の保存の口（RosterAttendance2Policy）も同じ決まりで断る。

                              押せない勤怠2は、disabled で検証から外す。vee-validate 3 は
                              provider の disabled しか見ない（select の disabled は見ない）。
                            -->
                            <ValidationProvider
                              :name="[index + 1] + '日の勤怠2'"
                              :rules="{ select: attendance2Required(index) }"
                              :disabled="devide[index] || readOnly"
                              v-slot="provider"
                            >
                              <select
                                style="margin-bottom: 3px"
                                class="custom-select preika-control--choice"
                                v-model="attendance2[index]"
                                v-bind:disabled="devide[index] || readOnly || globalLoading"
                                :tabindex="[index] + 5"
                              >
                                <option disabled value>未選択</option>
                                <option
                                  v-for="option2 in visibleOptions2At(index)"
                                  :value="option2.id"
                                  :key="option2.id"
                                >
                                  {{ option2.name }}
                                </option>
                              </select>
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                            <!-- 勤怠2の入力可否を記載 -->
                            <input type="hidden" :value="afternoon" />
                          </td>
                          <td>
                            <ValidationProvider
                              :name="[index + 1] + '日の備考・作業内容'"
                              rules=""
                              v-slot="provider"
                            >
                              <CInput
                                style="margin-bottom: 3px; width: 200px;"
                                type="text"
                                v-model="remarks[index]"
                                :disabled="readOnly || globalLoading"
                                :tabindex="[index] + 6"
                              />
                              <p class="roster-field-error">
                                {{ provider.errors[0] }}
                              </p>
                            </ValidationProvider>
                          </td>
                          <!-- プロジェクト -->
                          <td>
                            <select
                              class="custom-select preika-control--reference"
                              style="margin-bottom: 3px"
                              v-model="projectId[index]"
                              :disabled="readOnly || globalLoading"
                              @change="onChangeProject(index)"
                            >
                              <option
                                v-for="opt in projectOptions"
                                :key="opt.id"
                                :value="opt.id"
                              >
                                {{ opt.name }}<template v-if="opt.external">（現在所属外）</template>
                              </option>
                            </select>
                          </td>
                          <!-- 勤務時間のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <DailyWork
                              :monthDay="monthDay"
                              :index="index"
                              :total="dailyWorkResult"
                            ></DailyWork>
                          </td>
                          <!-- 時間外のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <OverTime
                              :dailyWorkResult="dailyWorkResult"
                              :workTimeUnit="workTimeUnit"
                              :workBasic="workBasic"
                              :index="index"
                              :attendance1="attendance1"
                              :attendance2="attendance2"
                              @updateOverTime="handleOvertimeUpdate"
                            ></OverTime>
                          </td>
                          <!-- 夜勤のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <NightWork
                              :monthDay="monthDay"
                              :start="start"
                              :end="send_end"
                              :nightRest="nightRest"
                              :attendance1="attendance1"
                              :earlyMorningShiftBasic="earlyMorningShiftBasic"
                              :lateNightShiftBasic="lateNightShiftBasic"
                              :midnightBasic="midnightBasic"
                              :nightShiftTimes="nightShiftTimes"
                              :dateChangeShiftTimes="dateChangeShiftTimes"
                              :index="index"
                              @updateNightTime="handleNightTimeUpdate"
                            ></NightWork>
                          </td>
                          <!-- 休日のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <HolidayWork
                              :monthDay="monthDay"
                              :start="start"
                              :end="send_end"
                              :rest="rest"
                              :attendance1="attendance1"
                              :index="index"
                              @updateHolidayWork="handleHolydayWorkUpdate"
                            ></HolidayWork>
                          </td>
                          <!-- 控除のコンポーネント呼出 -->
                          <td style="width: 0%">
                            <Deduction
                              :monthDay="monthDay"
                              :startBasic="startBasic"
                              :endBasic="endBasic"
                              :breakBasic="breakBasic"
                              :start="start"
                              :end="send_end"
                              :rest="rest"
                              :attendance1="attendance1"
                              :attendance2="attendance2"
                              :workBasic="workBasic"
                              :breakStartBasic="breakStartBasic"
                              :breakEndBasic="breakEndBasic"
                              :index="index"
                              @updateDeduct="handleDeductionUpdate"
                            ></Deduction>
                          </td>
                        </tr>
                        <tr v-if="stampOpenIndex === index" class="roster-stamp-history-row">
                          <td colspan="20">
                            <div class="roster-stamp-history" :data-testid="'roster-stamp-history-' + (index + 1)">
                              <strong>打刻履歴</strong>
                              <p v-if="!stampEventsAt(index).length">打刻記録はありません</p>
                              <table v-else>
                                <thead>
                                  <tr>
                                    <th>区分</th>
                                    <th>打刻時刻</th>
                                    <th>受信時刻</th>
                                    <th>打刻場所</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(event, eventIndex) in stampEventsAt(index)" :key="eventIndex">
                                    <td>{{ stampKindLabel(event) }}</td>
                                    <td>{{ stampEventTime(event) }}</td>
                                    <td :class="{ 'roster-stamp-history__gap': stampClockGapIsLarge(event) }">{{ stampReceivedTime(event) }}</td>
                                    <td :title="stampCoordinatesText(event)">
                                      {{ stampLocationText(event) }}
                                      <strong v-if="stampOutOfRangeText(event)" class="roster-stamp-history__gap">{{ stampOutOfRangeText(event) }}</strong>
                                      <a
                                        v-if="stampMapUrl(event)"
                                        :href="stampMapUrl(event)"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >地図を表示</a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <!-- DBから取得したID -->
                      <!-- <input v-for="(n, index) in monthDay" :key="index" type="hidden" v-model="id[index]" name="id" readonly> -->
                      <!-- 送信用としてTime型に変換した入力値の配列 -->
                      <input type="hidden" :value="sendStart" readonly />
                      <input type="hidden" :value="sendEnd" readonly />
                      <input type="hidden" :value="sendBreak" readonly />
                    </table>
                  </div>
                  <!--
                    表の横スクロールバーは、表の箱の下端にしか無く、縦に一番下まで送らないと見えなかった
                    （画面の上の行を直しているときに右の列へ送れない。2026-10-03 の要望）。表の箱の下に、
                    画面の下端へ張り付く横スクロールバーを1本置き、表の横位置と行き来でそろえる。表の箱
                    そのものの横スクロールバーは隠す（2本並べない）。一番下まで送ったときは、このバーが
                    そのまま表のすぐ下に収まる。
                  -->
                  <div
                    v-show="rosterScrollWidth > rosterClientWidth + 1"
                    ref="rosterHScroll"
                    class="roster-hscroll"
                    aria-hidden="true"
                    @scroll="onRosterHScroll"
                  >
                    <div class="roster-hscroll__track" :style="{ width: rosterScrollWidth + 'px' }"></div>
                  </div>
                </CRow>
              </div>
            </form>
          </ValidationObserver>
        </CCardBody>
        <CCardBody>
          <CRow v-if="success3.length">
            <ul>
              <li
                style="color: blue"
                v-for="success in success3"
                :key="success"
              >
                {{ "※" + success }}
              </li>
            </ul>
          </CRow>
          <!-- 累計時間のコンポーネント呼出 -->
          <MonthlyData
            ref="monthly"
            key="keyChild"
            :validateBeforeSave="validateBeforeSave"
            :today="today"
            :fromExternal="fromExternal"
            :monthDay="monthDay"
            :outBasic="outBasic"
            :startBasic="startBasic"
            :endBasic="endBasic"
            :breakBasic="breakBasic"
            :earlyMorningShiftBasic="earlyMorningShiftBasic"
            :lateNightShiftBasic="lateNightShiftBasic"
            :midnightBasic="midnightBasic"
            :nightShiftTimes="nightShiftTimes"
            :dateChangeShiftTimes="dateChangeShiftTimes"
            :start="start"
            :end="send_end"
            :rest="rest"
            :nightRest="nightRest"
            :attendance1="attendance1"
            :attendance2="attendance2"
            :remarks="remarks"
            :year="selectYear"
            :month="selectMonth"
            :totalTime="dailyWorkResult"
            :overTime="overTimeData"
            :nightWork="nightTimeData"
            :holiday="holiDayWorkData"
            :deduct="deductionData"
            :statusBtn="statusBtn"
            :waiting="globalLoading"
            :lockReason="lockReason"
            :userId="user_id"
            :paid="paid"
            :paidUnresolved="paidUnresolved"
            :paidDaysUsed="paidDaysUsed"
            :paidDaysAdd="paidDaysAdd"
            :instead="instead"
            :get_paid="get_paid"
            :addInstead="addInstead"
            :items="items"
            :projectId="projectId"
            :daily-version="dailyVersion"
            :base-time-min="baseTimeMin"
            :base-time-max="baseTimeMax"
            @updateAllData="reloadShownMonth"
            @saving-change="onSavingChange"
          ></MonthlyData>
        </CCardBody>
      </template>
    </CCard>
    <!--
      CoreUI 3.0.0 に CModalHeader / CModalBody は無い（未登録の要素として本文へ落ち、
      題名が見出しの帯に入らなかった）。業務報告の小窓（MonthlyReport.vue）と同じく title で出す。
    -->
    <CModal title="勤怠の説明" :show.sync="attendanceHelpOpen" size="lg" centered>
        <div v-if="attendanceHelpKind === '1'">
          <div style="font-weight: bold; margin-bottom: 8px;">勤怠1（その日の区分：終日／午前側）</div>
          <div>勤怠1は、その日の扱い（終日、または午前側の区分）を選択します。</div>
          <!-- 区分の名前は rosterAttendanceKinds.js の表から出す。どの区分も4つの組のどれかに入る。 -->
          <ul style="margin-top: 8px;">
            <li><b>{{ guideNames.work }}</b>：通常勤務（開始/終了/休憩/夜勤休憩を入力）</li>
            <li><b>{{ guideNames.halfDay }}</b>：午前側の区分。午後側は勤怠2で指定します</li>
            <li><b>{{ guideNames.shift }}</b>：始業時間の変更がある日（選択すると勤怠2は自動で「シフト」になります）</li>
            <li><b>{{ guideNames.clearsTimes }}</b>：選択すると時間入力欄は自動で空欄になります</li>
          </ul>
          <div style="margin-top: 8px;">※ 勤怠2が選択可能なときだけ、勤怠2のプルダウンが有効になります。</div>
          <div>※ 休日に出勤した日は、{{ guideNames.holiday }}を選択してから時刻と休憩を入力してください。</div>
        </div>

        <div v-else>
          <div style="font-weight: bold; margin-bottom: 8px;">勤怠2（午後側／終業側の区分）</div>
          <div>勤怠2は、午前側が特殊な日の「午後側（または終業側）」の扱いを指定します。</div>
          <ul style="margin-top: 8px;">
            <li v-for="kind in options2" :key="kind.id"><b>「{{ kind.name }}」</b>：{{ kind.help }}</li>
          </ul>
          <div style="margin-top: 8px;">
            ※ 勤怠1が{{ guideNames.opensAttendance2 }}のときのみ選択できます。
          </div>
        </div>
      <template #footer>
        <button class="btn btn-secondary" @click="closeAttendanceHelp">閉じる</button>
      </template>
    </CModal>
    <div v-if="globalLoading" class="loading-overlay" aria-live="polite" aria-busy="true">
      <CSpinner color="primary" style="width: 3rem; height: 3rem;" />
    </div>
  </div>
</template>

<script>
import MonthlyData from "./MonthlyData";
import DailyWork from "./DailyWork";
import Deduction from "./Deduction";
import HolidayWork from "./HolidayWork";
import NightWork from "./NightWork";
import OverTime from "./OverTime";
import RestInput from "./RestInput";
import axios from "axios";
import moment from "moment";
import ConstList from "./../ConstList";
import { requestFailureMessage } from '@/utils/requestFailure';
import { leaveWhenDetailIsRefused } from '@/utils/detailReadRefused';
import SubmissionConst from "./../submission_approval/ConstList";
import { submissionLockReason } from '../utils/submissionLockReason';
import RosterFileImport from './RosterFileImport';
import SaveButton from '../common/SaveButton';
import { normalizeTimeValue } from '../utils/timeValue';
import { endsOnNextDay } from '../utils/rosterDayCrossing';
import {
  canApplyScheduledTimes,
  clearsTimesForAttendance,
  isFutureRosterIndex,
  isPastRosterIndex,
  rosterDateKey,
  showsScheduleCandidate,
  usesAttendance2,
} from '../utils/rosterActualPolicy';
import { getCachedAccessContext } from '../services/accessContext';
import {
  ATTENDANCE1_KINDS,
  ATTENDANCE2_KINDS,
  ATTENDANCE_GUIDE_NAMES,
  CLEARS_TIMES_IDS,
  attendance2IsRequired,
} from './rosterAttendanceKinds';
import RosterStampOrigin from './RosterStampOrigin';
import { askedYearMonth } from '../utils/askedYearMonth';

// 勤怠1でこの区分を選ぶと、時刻の欄を空にし、定時の候補も出さない（休日・有給・代休・欠勤・特休有給）。
// 空にする処理（autoTime）と候補の出し分け（showsCandidate）が、この1つの並びを見る。
// 並びそのものは勤怠区分の表（rosterAttendanceKinds.js）の clearsTimes から作る。
const NO_TIME_ATTENDANCE_IDS = CLEARS_TIMES_IDS;

export default {
  name: "Roster",
  // 入力区分（打刻・打刻後修正・手入力）と打刻履歴。判定は utils/stampOrigin.js。
  mixins: [RosterStampOrigin],
  components: {
    MonthlyData,
    DailyWork,
    Deduction,
    HolidayWork,
    NightWork,
    OverTime,
    RosterFileImport,
    RestInput,
    SaveButton,
  },
  props: {
    externalUserId: [String, Number],
    externalYear: Number,
    externalMonth: Number,
    externalUserName: String,
    fromExternal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      user_id: "",
      user_name: "",
      project: "",
      projectList: [],
      outBasic: "05:00",
      startBasic: [],
      endBasic: [],
      breakBasic: [],
      // 案件の休憩の時間帯（始まり・終わり）。控除が、いなかった時間に重なる休憩を引かないために使う。
      breakStartBasic: [],
      breakEndBasic: [],
      preBuffer: [],
      postBuffer: [],
      workTimeUnit: [],
      workBasic: [],
      postWorkBreakFlg: [], 
      earlyMorningShiftBasic: "5:00",
      lateNightShiftBasic: "22:00",
      midnightBasic: "24:00",
      nightShiftTimes: "05:00",
      dateChangeShiftTimes: "02:00",
      // 休暇の残数（月の集計 MonthlyData へ渡す）。一覧を読んだところ（callList）で入る。
      // data に無いと、最初の描画で「未定義」の警告が出て、Vue も変化を追わなかった。
      // null は ?? で 0 と同じに扱われるので、読み込む前の見え方は今までと変わらない。
      paid: null,
      // 有給の前月残・今月発生・今月残をその月の時点へ戻せなかった（back が印を付ける）。
      paidUnresolved: false,
      paidDaysUsed: null,
      paidDaysAdd: null,
      get_paid: null,
      instead: null,
      addInstead: null,
      monthDay: [],
      computedOvertime: [], // ここで計算した時間外労働のデータを保持
      id: [],
      dailyVersion: [],
      date: [],
      hour: [],
      minutes: [],
      start: [],
      end: [],
      rest: [],
      nightRest: [],
      project_name: [],
      projectId: [],            // 日別の project_id を保持
      projectOptions: [],       // [{id, name, external?: true}]（所属外は external 表示のみ）
      attendance1: [],
      attendance2: [],
      // 勤怠1・勤怠2の選択肢。名前と入力の決まりは rosterAttendanceKinds.js の表に1か所で持つ。
      // 入力手順と勤怠1・勤怠2の説明（guideNames）も同じ表から作る。
      options: ATTENDANCE1_KINDS,
      options2: ATTENDANCE2_KINDS,
      guideNames: ATTENDANCE_GUIDE_NAMES,
      remarks: [],
      devide: [],
      items: [],
      baseTimeMin: [],
      baseTimeMax: [],
      start_time: [],
      end_time: [],
      break_time: [],
      today: [],
      success3: [],
      status: [],
      errors: [],
      displayFlg: false,
      send_end: [],
      total: [],
      showYearMonth: false,
      /*
       * 見出しに出している年月（［表示］を押した月）。保存の部品へはこちらを渡す。
       * 年月の選択欄（year/month）を渡していたので、選択欄だけ変えて［保存］すると、
       * 見えている月の実績を別の月として保存していた。
       */
      selectYear: "",
      selectMonth: "",
      // 承認状態による登録ボタンの非活性化
      statusBtn: false,
      loading: false,
      bulkProjectId: "",// 一括変更用（初期は空欄）
      rosterScrollWidth: 0, // 表の横の長さ（画面の下端に張り付く横スクロールバーの長さ）
      rosterClientWidth: 0, // 表の箱の見えている幅（表が収まっているときはバーを出さない）
      bulkApplying: false, 
      // 案件の設定（定時・休憩・猶予）を待っている本数（行のプロジェクトの変更・取り込みの反映）。
      // 待っているあいだは、読み込み中と同じ幕を出して入力と保存を止める（globalLoading）。
      basicsWaiting: 0,
      // 保存の送信中か（月の合計の部品 MonthlyData が、送り始めと終わりを知らせる）。
      saving: false,
      attendanceHelpOpen: false,
      attendanceHelpKind: "1",
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
    // 読み込み（callList）を頼んだ回数。応答は、いちばん新しく頼んだ1本のものだけ採る。
    this.listRequestSeq = 0;
    // 行ごとの、案件の設定を最後に頼んだ番号（行のプロジェクトを続けて変えたとき、最後に選んだ案件で決める）。
    this.projectRequestSeq = {};
    // 案件の設定をまとめて読んだ（hydrateDailyBasicsByProject）回数。応答は、いちばん新しく頼んだ1本だけ採る。
    this.basicsRequestSeq = 0;
  },
  methods: {
    /*
     * 画面の下端に張り付く横スクロールバー（.roster-hscroll）と、表の箱（.roster-table-scroll）の横位置を
     * 行き来でそろえる。同じ値を入れ直しても scroll は出ないので、往復で止まらなくなることはない。
     */
    startRosterHScroll() {
      window.addEventListener("resize", this.measureRosterScroll);
      this.watchRosterTable();
    },
    // 表は読み込みのたびに作り直される（displayFlg）。描画のあとに今の表と表の箱を確かめ、見張っている
    // 要素と違うときだけ見張りを付け替える。mounted の時点では表がまだ無いので、そこで付けるだけでは
    // 実際の表を見張れていなかった（2026-10-03 の監査 HSC-1。親の再描画を伴わずに表だけ広がると、
    // バーの長さが古いままになり、表を右へ送ってもバーの上限へ引き戻された）。
    watchRosterTable() {
      const box = this.$refs.rosterTableScroll;
      const table = box ? box.querySelector("table") : null;
      if (table !== this.rosterWatchedTable) {
        if (this.rosterResizeObserver) this.rosterResizeObserver.disconnect();
        this.rosterResizeObserver = null;
        this.rosterWatchedTable = table;
        if (table && typeof window.ResizeObserver === "function") {
          this.rosterResizeObserver = new window.ResizeObserver(() => this.measureRosterScroll());
          this.rosterResizeObserver.observe(table);
          this.rosterResizeObserver.observe(box);
        }
      }
      this.measureRosterScroll();
    },
    measureRosterScroll() {
      const box = this.$refs.rosterTableScroll;
      if (!box) return;
      const width = box.scrollWidth || 0;
      const visible = box.clientWidth || 0;
      if (width !== this.rosterScrollWidth) this.rosterScrollWidth = width;
      if (visible !== this.rosterClientWidth) this.rosterClientWidth = visible;
    },
    onRosterTableScroll() {
      const box = this.$refs.rosterTableScroll;
      const bar = this.$refs.rosterHScroll;
      if (box && bar && bar.scrollLeft !== box.scrollLeft) bar.scrollLeft = box.scrollLeft;
    },
    onRosterHScroll() {
      const box = this.$refs.rosterTableScroll;
      const bar = this.$refs.rosterHScroll;
      if (box && bar && box.scrollLeft !== bar.scrollLeft) box.scrollLeft = bar.scrollLeft;
    },
    /**
     * 利用者への知らせ。この画面では、今までどおり確認の小窓（alert）で出す。
     *
     * 呼び出しを1か所へ集めてあるのは、この部品を画面に出さずに動かす包み
     * （RosterHeadless.js。打刻のあと、勤務表と同じ計算を流すときに使う）が、
     * 小窓を出さずに文を受け取れるようにするため。ここを書き換えると、
     * 勤務表の知らせの出方がすべて変わる。
     */
    notify(message) {
      alert(message);
    },

    /**
     * 保存の前に、入力欄の検証を通す。
     *
     * **通らなければ false を返して保存を止める。**
     * いままで ValidationObserver は置いてあるだけで誰も見ておらず、
     * 開始時刻を空のまま保存できていた。
     *
     * 最初に見つかった欄まで画面を送る——31行ある表で
     * 「どこかが赤い」とだけ言われても探せない。
     */
    async validateBeforeSave () {
      const obs = this.$refs.obs
      if (!obs) return true

      const ok = await obs.validate()
      if (ok) return true

      await this.$nextTick()
      const first = this.$el.querySelector('.roster-field-error')
      if (first && first.scrollIntoView) {
        first.scrollIntoView({ block: 'center' })
      }
      return false
    },

    // $setのタイミング次第では古い値を子コンポーネントに渡す可能性があるため、遅延を入れる
    // Vue2の仕様で、配列の中身が変わっても「参照が同じ」だとcomputedのメソッドが発火しないため、
    // すべての要素を新しい配列で再代入
    // 差し替えは try の中で行い、失敗しても必ず「済んだ」と数える（childValueApplied の説明を参照）。
    handleOvertimeUpdate({ index, value }) {
      this.childValueArrived();
      this.$nextTick(() => {
        try {
          this.overTimeData = [...this.overTimeData];
        } finally {
          this.childValueApplied();
        }
      });
      this.$set(this.overTimeData, index, value);
    },
    handleNightTimeUpdate({ nights, index, value }) {
      this.childValueArrived();
      this.$nextTick(() => {
        try {
          this.nightTimeData = [...nights];
        } finally {
          this.childValueApplied();
        }
      });
      this.$set(this.nightTimeData, index, value);
    },
    handleHolydayWorkUpdate({ index, value }) {
      this.childValueArrived();
      this.$nextTick(() => {
        try {
          this.holiDayWorkData = [...this.holiDayWorkData];
        } finally {
          this.childValueApplied();
        }
      });
      this.$set(this.holiDayWorkData, index, value);
    },
    handleDeductionUpdate({ index, value }) {
      this.childValueArrived();
      this.$nextTick(() => {
        try {
          this.deductionData = [...this.deductionData];
        } finally {
          this.childValueApplied();
        }
      });
      this.$set(this.deductionData, index, value);
    },
    /*
     * この行の勤怠2を、選ばないと保存できないか。決まりは rosterAttendanceKinds.js の
     * attendance2IsRequired（その行の勤怠1で決める。前に保存した行を変えずに保存し直す
     * ときは求めない）。読み込んだときの行（items）と比べる。
     */
    attendance2Required(index) {
      const saved = this.items && this.items[index] ? this.items[index] : null;
      return attendance2IsRequired({
        attendance1: this.attendance1[index],
        savedRow: saved
          ? {
              id: saved[ConstList.ID],
              attendance1: saved[ConstList.ATTENDANCE1],
              attendance2: saved[ConstList.ATTENDANCE2],
            }
          : null,
      });
    },

    /*
     * 子の値を受けて配列を差し替えたあと、勤務表を1回だけ描き直す。
     *
     * 時間外・夜勤・法定休日・控除の4本の配列は、描画のきっかけにならない持ち方をしている。
     * 差し替えても勤務表は描き直されず、月の合計（MonthlyData）は、勤務表が次に描かれるまで
     * 古い配列を持ち続けていた。最後の操作のあとに描画が起きない入力（日曜に時刻を入れる、
     * 勤怠1を欠勤へ変えるだけ、プロジェクトを変える、など）では、日ごとの値は新しく、
     * 月の合計だけ古いまま保存された。月の合計は画面が送った値がそのまま保存されるので、
     * 勤務表と月次集計で数字が食い違ったままになる。
     *
     * **4本を、描画のきっかけになる持ち方（data）へは変えない。**描画の回数が16〜30倍になる
     * （2026-10-01 に実測。開く 8回→131回）。
     *
     * 子の値は、1回の入力で行の数ぶん（4種類×日数）続けて届く。届いた数を数えておき、
     * 差し替えを待っている値が無くなったところで1回だけ描き直す（1本ごとに描き直すと、
     * 遅れて届く法定休日・控除の差し替えの前に1回、後に1回と、余分に描くことになる）。
     * 描き直しでは子の値が変わらないので、ここへは戻ってこない（回り続けない）。
     *
     * **届いた値は、差し替えに失敗しても必ず「済んだ」と数える**（受け口の try / finally）。
     * 数えそこねると、待っている値がいつまでも残り、その画面では以後1度も描き直されなくなる
     * （月の合計だけ古い、直す前の動きへ黙って戻る）。
     */
    childValueArrived() {
      this.childValuesWaiting = (this.childValuesWaiting || 0) + 1;
    },
    childValueApplied() {
      this.childValuesWaiting = (this.childValuesWaiting || 0) - 1;
      if (this.childValuesWaiting <= 0) {
        this.childValuesWaiting = 0;
        this.$forceUpdate();
      }
    },
    /*
     * 開始・終了がそろった行で、打刻が入れた夜勤休憩 00:00（夜の休憩は打刻していない）を空へ戻す。
     *
     * 時刻欄を変えたとき（autoRestTime の中）と、ファイル取り込みで開始か終了が変わった行の仕上げが、
     * 同じ処理を通る。どの行がそうかを知っているのは、この部品を包む Roster.js（打刻した日の決まりを持つ）。
     * この部品だけでは、何もしない。
     */
    // eslint-disable-next-line no-unused-vars
    clearUnstampedNightRestAt(index) {},

    /*
     * 夜勤休憩の欄へ利用者が値を入れた（勤務表の手入力・ファイル取り込み）ことを、打刻した日の決まりへ伝える。
     * 入れた値は、打刻が入れた 00:00 とはみなさない。決まりを持つのは Roster.js。この部品だけでは、何もしない。
     */
    // eslint-disable-next-line no-unused-vars
    markNightRestEntered(index) {},

    onUpdateRest({ index, value }) {
      this.$set(this.rest, index, value);
    },

    /*
     * その行の休憩を「手で直した休憩」として固定しているか。休憩の欄の下の文の出し分けに使う。
     *
     * 固定の状態を持つのは、この部品を包む Roster.js（画面と管理者用の勤務表が使う）。
     * この部品だけでは休憩を固定しないので、いつも false。
     */
    isRestManual() {
      return false;
    },

    /*
     * ファイル取り込みで、その行の休憩を「空欄」と同じに扱うか。
     *
     * 取り込みの「空欄だけに反映」は、入力済みの欄を変えない。ただし、利用者が入力していない休憩
     * （出勤を打刻したときに入った休憩）は、入力済みとは数えない。ファイルに休憩が書いてあれば、
     * その値を入れる。
     *
     * どの行がそうかを知っているのは、この部品を包む Roster.js（打刻した日の決まりを持つ）。
     * この部品だけでは、いつも false（休憩が入っている行は、入力済み）。
     * 取り込みの小窓の確認の表（RosterFileImport.vue）も、同じ答えを使う（importRestAsBlank）。
     */
    restCountsAsBlankForImport() {
      return false;
    },

    /*
     * ファイル取り込みで、その行の夜勤休憩を「空欄」と同じに扱うか。
     *
     * 休憩の打刻が入れた夜勤休憩 00:00（夜の休憩は打刻していない）は、利用者が入力した値ではない。
     * 「空欄だけに反映」でも、ファイルに夜勤休憩が書いてあれば、その値を入れる。
     *
     * どの行がそうかを知っているのは、この部品を包む Roster.js（打刻した日の決まりを持つ）。
     * この部品だけでは、いつも false（夜勤休憩が入っている行は、入力済み）。
     * 取り込みの小窓の確認の表（RosterFileImport.vue）も、同じ答えを使う（importNightRestAsBlank）。
     */
    nightRestCountsAsBlankForImport() {
      return false;
    },

    // DBから一覧呼出メソッド
    //
    // **応答は、いちばん新しく頼んだ1本のものだけ採る**（seq）。読み込みの途中でもう一度読み込むと
    // （保存のあとの読み直し・［表示］の押し直し）、前の1本の応答があとから返って、次の表へ書いたり、
    // 前の1本の終わりで幕（loading）が先に消えて、読み込みの最後の判定（手で直した休憩の固定）が
    // 1度も走らなかったりした。古い1本は、表・知らせ・loading のどれにも触らない。
    callList: function () {
      this.listRequestSeq = (this.listRequestSeq || 0) + 1;
      const seq = this.listRequestSeq;
      const isLatest = () => seq === this.listRequestSeq;
      this.loading = true;
      this.monthDay = [];
      this.id = [];
      this.dailyVersion = [];
      this.date = [];
      this.total = [];
      this.start = [];
      this.end = [];
      this.rest = [];
      this.nightRest = [];
      this.project_name = [];
      this.projectOptions = []
      this.attendance1 = [];
      this.attendance2 = [];
      this.remarks = [];
      this.dailyWork = [];
      this.overTimeData = [];
      this.nightTimeData = [];
      this.holiDayWorkData = [];
      this.deductionData = [];
      this.preBuffer = [];
      this.postBuffer = [];
      this.postWorkBreakFlg = [];
      this.workTimeUnit = [];
      this.workBasic = [];
      (this.status = []), (this.errors = []), (this.displayFlg = false);
      this.statusBtn = false;
      // 見出しの月と日の並びは、頼んだ月で作る。応答が返った時点の選択欄から作っていたので、
      // 待つあいだに選択欄を変えると、前の月の実績に次の月の見出しと日付が付き、その月へ保存していた。
      const year = this.year;
      const month = this.month;
      const params = new URLSearchParams();
      params.append("year", year);
      params.append("month", month);
      // 本人用の /select は対象者をログインセッションで確定するため、
      // userId を送っても無視される（バックエンドの引数名は ignoredUserId）。
      // 管理者が他スタッフの勤務表を開く場合は、対象者を受け取る
      // /admin/rosterSelect を使わないと自分自身の勤務表が表示されてしまう。
      const rosterRequest = this.fromExternal
        ? axios.get(process.env.VUE_APP_API_ORIGIN + "/admin/rosterSelect", {
            params: {
              user_id: this.user_id,
              year: year,
              month: month,
            },
          })
        : axios.get(process.env.VUE_APP_API_ORIGIN + "/select", {
            params: {
              year: year,
              month: month,
            },
          });
      rosterRequest
        .then((response) => {
          if (!isLatest()) return;
          this.item = [];
          this.monthDay = [];
          this.items = response.data;
          this.displayFlg = true;
          this.showYearMonth = true;
          this.selectYear = year;
          this.selectMonth = month;
          // 入力区分の印に使う。読めなくても勤務表は動かす（印が出ないだけ）。
          this.loadStampEvents(year, month);
          const paddedMonth = String(month).padStart(2, "0"); // "01"〜"12"

          const startDate = moment(`${year}-${paddedMonth}-01`)
            .startOf("month")
            .locale("ja", {
              weekdays: ["日", "月", "火", "水", "木", "金", "土"],
            });

          const endDate = moment(`${year}-${paddedMonth}-01`)
            .endOf("month")
            .locale("ja", {
              weekdays: ["日", "月", "火", "水", "木", "金", "土"],
            });

          while (startDate.unix() <= endDate.unix()) {
            this.monthDay.push(startDate.format("D日 (dd)"));
            startDate.add(1, "days");
          }

          // ユーザID取得
          if (this.items?.length && !this.user_id) {
            this.user_id = this.items[0][ConstList.USER_ID];
          }

          // ユーザー所属プロジェクト一覧を取得。
          // /projects はログイン利用者本人の所属を返すため、管理者が他スタッフを
          // 開いている場合は使わない（対象者の所属を返すAPIは存在しない）。
          // 外部モードでは勤務表の行に現れるプロジェクトから選択肢を組み立てる。
          return (this.fromExternal
            ? Promise.resolve({ data: [] })
            : axios.get(process.env.VUE_APP_API_ORIGIN + "/projects", {}))
            .then(({ data: projList }) => {
            if (!isLatest()) return;
            // 1) 所属（数値IDで正規化）
            const belong = (projList || []).map(p => ({ id: +p.id, name: p.name }));
            const belongIdSet = new Set(belong.map(p => p.id));

            // 2) 履歴に出てくるプロジェクト（存在するIDだけ拾う）
            const fromItems = (this.items || [])
              .map(r => {
                const id = r[ConstList.PROJECT_ID];
                if (id === null || id === undefined || isNaN(+id)) return null;
                return { id: +id, name: r[ConstList.PROJECT_NAME] || `(ID:${+id})` };
              })
              .filter(Boolean);

            // 3) 所属＋履歴をIDでユニーク化し、所属外には external フラグ
            const map = new Map();
            [...belong, ...fromItems].forEach(p => {
              if (!map.has(p.id)) {
                map.set(p.id, {
                  id: p.id,
                  name: p.name,
                  external: !belongIdSet.has(p.id),
                });
              }
            });
            this.projectOptions = Array.from(map.values());

            // 4) 各日の選択値を一気に作る（saved がなければ先頭を既定）
            const defaultId = this.projectOptions[0]?.id ?? null;
            this.projectId = (this.items || []).map(r => {
              const saved = r[ConstList.PROJECT_ID];
              return (saved !== null && saved !== undefined && !isNaN(+saved))
                ? +saved
                : defaultId;
            });
            
            for (let i = 0; i < this.items.length; i++) {
              const days = moment(this.items[i][ConstList.DATE]);
              days.format("YYYY-MM-DD");
              const rowId = this.items[i][ConstList.ID];
              const suggestionOnly = rowId == null || this.isFutureIndex(i);
              this.id.splice(i, 1, rowId);
              this.dailyVersion.splice(i, 1, this.items[i][ConstList.DAILY_VERSION] ?? null);
              this.user_id = this.items[i][ConstList.USER_ID];
              this.start.splice(i, 1, suggestionOnly ? '' : (this.items[i][ConstList.START_TIME] || ''));
              this.end.splice(i, 1, suggestionOnly ? '' : (this.items[i][ConstList.END_TIME] || ''));
              // 入力区分：読み込んだ値を控える（いまの値がこれと違う欄は、いま書き換えている欄）。
              this.captureStampSavedTime(i, this.start[i], this.end[i]);
              this.rest.splice(i, 1, suggestionOnly ? '' : (this.items[i][ConstList.BREAK_TIME] || ''));
              this.nightRest.splice(
                i,
                1,
                suggestionOnly
                  ? ''
                  : normalizeTimeValue(this.items[i][ConstList.NIGHT_REST], '')
              );
              this.baseTimeMin.splice(i, 1, this.items[i][ConstList.BASE_TIME_MIN] ?? null);
              this.baseTimeMax.splice(i, 1, this.items[i][ConstList.BASE_TIME_MAX] ?? null);
              this.attendance1.splice(i, 1, this.items[i][ConstList.ATTENDANCE1]);
              this.attendance2.splice(i, 1, this.items[i][ConstList.ATTENDANCE2]);
              this.remarks.splice(i, 1, this.items[i][ConstList.REMARKS]);
              this.startBasic.splice(i, 1, this.items[i][ConstList.BASIC_START_TIME]);
              this.endBasic.splice(i, 1, this.items[i][ConstList.BASIC_END_TIME]);
              this.breakBasic.splice( i, 1, this.items[i][ConstList.BASIC_BREAK_TIME]);
              // 一覧は休憩の時間帯を返さない。前の月の値を残さないよう空にして、直後の案件の設定の読み直しで入れる。
              this.breakStartBasic.splice(i, 1, "");
              this.breakEndBasic.splice(i, 1, "");
              this.preBuffer.splice(i, 1, this.items[i][ConstList.PRE_BUFFER] || "");
              this.postBuffer.splice(i, 1, this.items[i][ConstList.POST_BUFFER] || "");
              this.workTimeUnit.splice(i, 1, this.items[i][ConstList.WORK_TIME_UNIT] || "");
              this.workBasic.splice(i, 1, this.items[i][ConstList.WORK_BASIC] || "");
              this.postWorkBreakFlg.splice(i, 1, !!this.items[i][ConstList.POST_WORK_BREAK_FLG]);
              this.status.splice(i, 1, this.items[i][ConstList.STATUS]);

              const status = this.items[i][ConstList.STATUS];

              // その月の時点へ戻せなかった印。承認済みの月は保存値なので付かない（back も false を返す）。
              this.paidUnresolved = status !== ConstList.APPROVAL
                && this.items[i][ConstList.PAID_UNRESOLVED] === true;
              if (status === ConstList.APPROVAL) {
                // 承認済 → t_monthly
                this.paid = this.items[i][ConstList.PAID_PRE] ?? "0";
                this.paidDaysUsed = this.items[i][ConstList.PAID_DAYS_USED] ?? "0";
                this.paidDaysAdd = this.items[i][ConstList.PAID_DAYS_ADD] ?? "0";
                this.get_paid = this.items[i][ConstList.PAID_ADDED] ?? "0";
                this.instead = this.items[i][ConstList.SUBSTITUTE_PRE] ?? "0";
                this.addInstead = this.items[i][ConstList.SUBSTITUTE_ADDED] ?? "0";
              } else {
                // 差戻・未申請・初回保存前 → t_user 由来
                this.paid = this.items[i][ConstList.PAID_PRE];
                this.paidDaysUsed = this.items[i][ConstList.PAID_DAYS_USED];
                this.paidDaysAdd = this.items[i][ConstList.PAID_DAYS_ADD];
                this.get_paid = this.items[i][ConstList.PAID_ADDED];
                this.instead = this.items[i][ConstList.SUBSTITUTE_PRE];
                this.addInstead = this.items[i][ConstList.SUBSTITUTE_ADDED];
              }

              // nullを空文字に統一
              this.dailyWork.splice(i, 1, this.items[i][ConstList.WORK_TIME] || "");
              this.overTimeData.splice(i, 1, this.items[i][ConstList.OVER_TIME] || "");
              this.nightTimeData.splice(i, 1, this.items[i][ConstList.NIGHT_WORK] || "");
              this.holiDayWorkData.splice(i, 1, this.items[i][ConstList.HOLIDAY] || "");
              this.deductionData.splice(i, 1, this.items[i][ConstList.DEDUCT] || "");
            }

            this.$nextTick(() => {
              this.$forceUpdate();
            });

            if (this.status[0] == ConstList.APPROVAL_PENDING) {
              this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_PENDING);
              this.statusBtn = true;
            }

            // 承認済み状態はメッセージ表示とボタン非活性化
            if (this.status[0] == ConstList.APPROVAL) {
              this.errors.push(SubmissionConst.ERROR_UPDATE_MESSAGE_APPROVAL);
              this.statusBtn = true;
            }
            // 初回表示（新規月含む）でも“その日のプロジェクト基準”で計算できるよう、日別に基準を流し込む
            return this.hydrateDailyBasicsByProject();
          })
        })
        .catch((error) => {
          if (!isLatest()) return;
          this.displayFlg = false;
          // ほかの人の勤務表を開いて断られたら、空の画面を残さず断りの画面へ移す。
          if (this.fromExternal && leaveWhenDetailIsRefused(this.$router, error)) return;
          axios
          .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(error) }, { headers: { 'Content-Type': 'application/json' } })
          .then(()=> {
              this.notify(requestFailureMessage(error));
            })
          .catch(()=> {
              this.notify(requestFailureMessage(error, ConstList.SYSTEM_COMMUNICATION_ERROR));
            });
        })
        .finally(() => {
          // いちばん新しい1本は、成功でも失敗でも必ず幕を戻す（固まらない）。
          if (isLatest()) this.loading = false;
        });
    },
    // 保存のあとの読み直し。保存したのは見出しの月なので、選択欄もその月へ戻して開き直す。
    // 選択欄の月で開き直すと、保存した月と違う月が出て、保存できたかが分からない。
    reloadShownMonth() {
      this.year = this.selectYear;
      this.month = this.selectMonth;
      this.callList();
    },
    // 日ごとの判定（過去日・当日・予定）は、見出しの月（表の行の月）で行う。選択欄の月で判定すると、
    // 選択欄だけ変えたときに当日を過去日と見て定時を入れたり、表示中の行を「予定」にしたりする。
    rosterDateKey(index) {
      return rosterDateKey(this.selectYear, this.selectMonth, index);
    },
    // 日ごとの判定（過去日・当日・予定）の「今日」（'YYYY-MM-DD'）。この画面では端末の日付。
    // 打刻のあとに勤務表を画面に出さずに流す包み（RosterHeadless.js）だけが、サーバの今日へ差し替える。
    rosterTodayKey() {
      return moment().format("YYYY-MM-DD");
    },
    isFutureIndex(index) {
      return isFutureRosterIndex({
        year: this.selectYear,
        month: this.selectMonth,
        index,
        todayKey: this.rosterTodayKey(),
      });
    },
    isPastIndex(index) {
      return isPastRosterIndex({
        year: this.selectYear,
        month: this.selectMonth,
        index,
        todayKey: this.rosterTodayKey(),
      });
    },
    schedulePlaceholder(value) {
      return value ? `候補 ${value}` : "実績未入力";
    },
    // その日の欄に定時の候補を出すか。休日・休暇・欠勤の日（時刻を空にする区分）には出さない。
    showsCandidate(index) {
      return showsScheduleCandidate({
        attendance: this.attendance1[index],
        noTimeIds: NO_TIME_ATTENDANCE_IDS,
      });
    },
    canApplyDefaultAt(index) {
      return canApplyScheduledTimes({
        year: this.selectYear,
        month: this.selectMonth,
        index,
        todayKey: this.rosterTodayKey(),
        attendance: this.attendance1[index],
        fullTimeId: ConstList.FULLTIME,
        start: this.start[index],
        end: this.end[index],
        startBasic: this.startBasic[index],
        endBasic: this.endBasic[index],
      });
    },
    applyDefaultAt(index) {
      if (!this.canApplyDefaultAt(index)) return false;
      this.$set(this.start, index, this.startBasic[index] || "");
      this.$set(this.end, index, this.endBasic[index] || "");
      this.$set(this.rest, index, this.breakBasic[index] || "");
      this.$set(this.nightRest, index, "00:00");
      this.autoRestTime(index);
      return true;
    },
    applyDefaultsToPast() {
      const candidates = this.monthDay
        .map((_, index) => index)
        .filter(index => this.isPastIndex(index) && this.canApplyDefaultAt(index));
      if (!candidates.length) {
        this.notify("過去の日付に対して、定時を反映できる空欄はありません。");
        return;
      }
      if (!window.confirm(
        `${candidates.length}日分の空欄へプロジェクト定時を実績として反映します。よろしいですか？`
      )) return;
      candidates.forEach(index => this.applyDefaultAt(index));
    },
    getDayClass(day,attendance) {
      const dayOfWeek = day.substring(
        day.lastIndexOf("(") + 1,
        day.lastIndexOf(")")
      );
      if (dayOfWeek === "土") return {blue: dayOfWeek === "土"};
      else if (attendance === 5) return {red: attendance === 5};
    },
    /*
     * 勤怠1の選択肢。半休を使わない会社では午前有給・午前代休・
     * 午前特休・午前欠勤を出さない。
     *
     * **午前欠勤も隠す。**休暇ではないが、このフラグは「休暇制度」では
     * なく半日という単位を扱うかを決めている。残すと、勤務表では
     * 選べるのに休暇申請の時間帯が「終日」だけで午前の欠勤申請を
     * 出せず、整合性の検査で**その月の勤務表を提出できなくなる。**
     * 実機で詰みを確認した。
     *
     * 半休を使わない会社で午前だけ来なかった日は、実際の出退勤時刻を
     * 入れて**遅刻**として控除する。控除額は半日欠勤と同じ4時間。
     *
     * **その行に既に入っている値は残す。**フラグを切ったあとに過去の
     * 勤務表を開いたとき、選択肢から消すと画面が空欄になり、
     * そのまま保存すると勤怠区分が消える。実機で見つけた。
     */
    visibleOptionsAt: function (index) {
      if (this.usesHalfDayLeave) return this.options;
      const 隠す = [
        ConstList.MORNING_PAID,
        ConstList.MORNING_SUBSTITUTE,
        ConstList.MORNING_SPECIAL_HOLIDAY,
        ConstList.MORNING_DEDUCTION
      ];
      const いまの値 = this.attendance1[index];
      return this.options.filter(
        o => !隠す.includes(o.id) || o.id === いまの値
      );
    },
    /**
     * 午前の休みと、それに対応する午後の休み。
     *
     * <p><b>同じ種類を午前と午後の両方には選ばせない。</b>1日まるごと
     * 休むなら終日の区分（有給・代休・特休・欠勤）を選ぶ。</p>
     *
     * <p>種類が違う組み合わせは残す。午前有給＋午後代休 は、有給が
     * 0.5日しか残っていない人が実際に取る形で、終日では表せない。</p>
     */
    午後の同じ種類: function (勤怠1) {
      if (勤怠1 === ConstList.MORNING_PAID) {
        return ConstList.AFTERNOON_PAID;
      }
      if (勤怠1 === ConstList.MORNING_SUBSTITUTE) {
        return ConstList.AFTERNOON_SUBSTITUTE;
      }
      if (勤怠1 === ConstList.MORNING_SPECIAL_HOLIDAY) {
        return ConstList.AFTERNOON_SPECIAL_HOLIDAY;
      }
      if (勤怠1 === ConstList.MORNING_DEDUCTION) {
        return ConstList.AFTERNOON_DEDUCTION;
      }
      return null;
    },
    /**
     * 勤怠2の選択肢。
     *
     * <p>半休を使わない会社では午後の半休と午後欠勤を出さない。
     * 午後出勤とシフトは残す。</p>
     *
     * <p><b>半休を使う会社でも、勤怠1と同じ種類の午後は出さない。</b>
     * 勤怠1を選ぶまで勤怠2は触れないが、触れるようになったあとの
     * 選択肢は絞られていなかった。午前欠勤＋午後欠勤を選べてしまい、
     * 1日休んでいるのに控除が半日ぶんしか出なかった。
     * 有給・代休・特休も同じ形。</p>
     *
     * <p><b>その行にいま入っている値は残す。</b>選択肢から消すと、
     * 過去の勤務表を開いたとき画面が空欄になり、そのまま保存すると
     * 勤怠区分が消える。この製品で実際に踏んでいる。</p>
     */
    visibleOptions2At: function (index) {
      const 隠す = this.hiddenOptions2At(index);
      if (!隠す.length) return this.options2;
      const いまの値 = this.attendance2[index];
      return this.options2.filter(
        o => !隠す.includes(o.id) || o.id === いまの値
      );
    },
    /**
     * その行で、勤怠2の選択肢に出さない区分（会社の設定と、その行の勤怠1で決まる）。
     *
     * <p><b>決まりはここ1か所。</b>選択肢の絞り込み（visibleOptions2At）と、勤怠1を変えたときの
     * 見直し（onAttendance1Change）が、同じこの並びを見る。</p>
     */
    hiddenOptions2At: function (index) {
      const 隠す = [];
      if (!this.usesHalfDayLeave) {
        隠す.push(
          ConstList.AFTERNOON_PAID,
          ConstList.AFTERNOON_SUBSTITUTE,
          ConstList.AFTERNOON_SPECIAL_HOLIDAY,
          ConstList.AFTERNOON_DEDUCTION
        );
      }
      const 同じ種類 = this.午後の同じ種類(this.attendance1[index]);
      if (同じ種類 !== null) {
        隠す.push(同じ種類);
      }
      return 隠す;
    },
    /**
     * 勤怠1の選択欄を、利用者が変えたとき。
     *
     * <p><b>いまの勤怠2が、新しい勤怠1では選べない区分なら、未選択に戻す。</b>
     * 選択肢の絞り込みは「その行にいま入っている値は残す」ので、勤怠1をあとから変えると、
     * 選べない組み合わせが残った。午前出勤＋午後有給で保存した日の勤怠1を午前有給へ変えると、
     * 午後有給が残り、新しく選ぶときには出ない「午前有給＋午後有給」のまま保存できた
     * （1日まるごと休むなら、終日の区分を選ぶ決まり）。未選択に戻せば、勤怠2の必須が効いて、
     * 選び直すまで保存できない。</p>
     *
     * <p><b>利用者が勤怠1の欄を変えたときだけ。</b>保存済みの月を開いただけでは何も変えない
     * （前に保存した値を、開いただけで消さない）。ファイルの取り込みは autoTime を直に呼ぶので、
     * ここは通らない（ファイルに書いてある勤怠2を、こちらで消さない）。</p>
     */
    onAttendance1Change: function (index) {
      this.autoTime(index);
      // 変数の名前は、上の visibleOptions2At の「いまの値」と変えてある
      // （CI が、あちらの1行を名指しで壊して確かめる。同じ字の行を2つにしない）。
      const いまの勤怠2 = this.attendance2[index];
      if (いまの勤怠2 === "" || いまの勤怠2 === null || いまの勤怠2 === undefined) return;
      if (this.hiddenOptions2At(index).includes(いまの勤怠2)) {
        this.attendance2.splice(index, 1, "");
      }
    },
    // 時間の自動入力
    autoTime: function (index) {
      const id1 = this.attendance1[index];

      // 勤怠1=シフト → 勤怠2も自動でシフト
      if (id1 === ConstList.SHIFT) {
        this.attendance2.splice(index, 1, ConstList.SHIFT);
      }
      if (clearsTimesForAttendance(id1, NO_TIME_ATTENDANCE_IDS)) {
        this.start.splice(index, 1, "");
        this.end.splice(index, 1, "");
        this.rest.splice(index, 1, "");
        this.nightRest.splice(index, 1, "");
      }
    },
    /*
     * 夜勤休憩の欄を変えたとき。
     *
     * 勤怠がシフトの日は、休憩の自動計算が夜勤休憩を見る（夜勤休憩を引いた実働が規定を超えた分だけ、
     * 定時後休憩を足す）。開始・終了の欄を変えたときにしか計算しないと、同じ入力でも
     * 「時刻 → 夜勤休憩」と「夜勤休憩 → 時刻」で休憩が違ってしまう。夜勤休憩を変えたときにも計算する。
     *
     * 開始か終了が空の行では計算しない。計算は時刻がそろっていない行の休憩を空にするので、
     * 夜勤休憩を入れただけで、入れてあった休憩が消えてしまうため。
     *
     * 勤怠がシフトでない日も計算しない。式が夜勤休憩を見るのはシフトの日だけで、ほかの日は
     * 計算しても値が変わらないはずだが、休憩を空にして保存してある日（休憩を取らなかった日）は
     * 「手で直した休憩」として固定されていないので、夜勤休憩を直しただけで、空だった休憩に
     * 自動の値が入ってしまう。
     *
     * 夜勤休憩の欄そのものは、ここからの計算では書き換えない（keepNightRest）。
     * 利用者が打っている最中の欄だから。
     */
    onNightRestChange(index) {
      if (this.attendance1[index] !== ConstList.SHIFT) return;
      if (!this.start[index] || !this.end[index]) return;
      this.autoRestTime(index, { keepNightRest: true });
    },
    // 休憩時間操作
    autoRestTime(index) {
      const start = this.start[index];
      const end = this.end[index];
      if (!start || !end) {
        this.rest.splice(index, 1, null);
        return;
      }

      const rBasic = moment.duration(this.breakBasic[index], "HH:mm");
      const postBuffer = moment.duration(this.postBuffer[index] ?? "00:00", "HH:mm");
      const startTime = moment.duration(start, "HH:mm");
      const endTimeRaw = moment.duration(end, "HH:mm");

      // 日付またぎ補正（終了 <= 開始 の場合は翌日扱い）
      const endTime = endTimeRaw.clone();
      if (endTime.asMinutes() <= startTime.asMinutes()) {
        endTime.add(24, "hours");
      }

      let restTime = rBasic.clone();

      if (this.postWorkBreakFlg[index]) {
        // SHIFT のときだけ：会社規定 workBasic(例:08:00) を基準に「実働が超えた分」を見て追加休憩を付与
        if (this.attendance1[index] === ConstList.SHIFT) {
          const wb = moment.duration(this.workBasic[index] ?? "00:00", "HH:mm");
          const nightRest = moment.duration(this.nightRest?.[index] ?? "00:00", "HH:mm");

          // 追加休憩を付ける前の実働（開始〜終了−基本休憩−夜勤休憩）
          const workedMin = endTime.clone().subtract(startTime).subtract(rBasic).subtract(nightRest).asMinutes();
          const overtimeMin = workedMin - wb.asMinutes();

          if (overtimeMin > 0) {
            const addMin = Math.min(postBuffer.asMinutes(), overtimeMin);
            restTime.add(moment.duration(addMin, "minutes"));
          }
        } else {
          // 常勤等は影響を出さない
          const endBase = moment.duration(this.endBasic[index], "HH:mm");
          const diffMin = endTime.asMinutes() - endBase.asMinutes();
          if (diffMin >= postBuffer.asMinutes()) {
            restTime.add(postBuffer);
          } else if (diffMin > 0) {
            restTime.add(moment.duration(diffMin, "minutes"));
          }
        }
      }

      const h = String(restTime.hours()).padStart(2, "0");
      const m = String(restTime.minutes()).padStart(2, "0");
      this.rest.splice(index, 1, `${h}:${m}`);
    },
    applyRosterFileImport ({ rows, overwriteMode, fillRestFromSchedule }) {
      const hasValue = value => value !== null && value !== undefined && String(value) !== '';
      // asBlank：その欄に値が入っていても、空欄と同じに扱う（「空欄だけに反映」でも入れる）。
      const applyValue = (target, index, value, asBlank = false) => {
        if (value === undefined) return false;
        if (overwriteMode === 'empty' && hasValue(target[index]) && !asBlank) return false;
        const current = target[index] == null ? '' : target[index];
        const next = value == null ? '' : value;
        if (String(current) === String(next)) return false;
        this.$set(target, index, value);
        return true;
      };

      let projectChanged = false;
      const touchedRows = [];
      // 行ごとの「休憩を空欄と同じに扱うか」。取り込みの小窓へ渡してあるのと同じ答え（importRestAsBlank）を、
      // 値を入れ始める前に写しておく（確認の表が見たのと同じ状態で決める。開始・終了を入れたあとでは変わる）。
      const restAsBlankRows = Array.isArray(this.importRestAsBlank) ? this.importRestAsBlank.slice() : [];
      // 同じく、行ごとの「夜勤休憩を空欄と同じに扱うか」（importNightRestAsBlank）。
      const nightRestAsBlankRows = Array.isArray(this.importNightRestAsBlank) ? this.importNightRestAsBlank.slice() : [];
      (rows || []).forEach(row => {
        if (!row || !Number.isInteger(row.index) || row.index < 0 || row.index >= this.monthDay.length) return;
        const index = row.index;
        const values = row.values || {};
        let changed = false;
        const restAsBlank = restAsBlankRows[index] === true;
        const nightRestAsBlank = nightRestAsBlankRows[index] === true;

        const changedProject = applyValue(this.projectId, index, values.projectId);
        projectChanged = changedProject || projectChanged;
        changed = changedProject || changed;
        // 開始か終了が、この取り込みで実際に変わったか（空欄だけに反映で、入力済みの欄は変わらない）。
        const changedStart = applyValue(this.start, index, values.start);
        const changedEnd = applyValue(this.end, index, values.end);
        changed = changedStart || changedEnd || changed;
        changed = applyValue(this.rest, index, values.rest, restAsBlank) || changed;
        const changedNightRest = applyValue(this.nightRest, index, values.nightRest, nightRestAsBlank);
        changed = changedNightRest || changed;
        // ファイルの夜勤休憩が欄に入った行（入る前と同じ値だった行も）は、勤務表で夜勤休憩の欄へ打った日と同じに扱う
        // （markNightRestEntered。打刻が入れた 00:00 とみなさず、下の仕上げで時刻が変わっても空へ戻さない）。
        // 勤務表で「終了 → 夜勤休憩」と打った日と同じ結果になる。
        if (hasValue(values.nightRest) && String(this.nightRest[index] ?? '') === String(values.nightRest)) {
          this.markNightRestEntered(index);
        }
        // 勤怠1・勤怠2が、この取り込みで実際に変わったか（空欄だけに反映で、入力済みの勤怠は変わらない）。
        const changedAttendance1 = applyValue(this.attendance1, index, values.attendance1);
        changed = changedAttendance1 || changed;
        const changedAttendance2 = applyValue(this.attendance2, index, values.attendance2);
        changed = changedAttendance2 || changed;
        changed = applyValue(this.remarks, index, values.remarks) || changed;

        if (changed || row.autoFillRest) {
          touchedRows.push({
            index,
            // 勤怠の選択欄を変えたときと同じ処理（autoTime）を呼ぶ行。勤務表で autoTime が付いているのは
            // 勤怠1の選択欄だけ（勤怠2の選択欄には変更時の処理が無い）なので、勤怠1が変わった行だけ。
            attendanceChanged: changedAttendance1,
            // 開始か終了が、この取り込みで実際に変わった（時刻欄を変えたときと同じ後始末をする行）。
            timeChanged: changedStart || changedEnd,
            autoFillRest: Boolean(row.autoFillRest),
            // ファイルに休憩が書いていない行で、開始か終了が変わった。
            // 時刻欄を直したときと同じく、休憩を計算し直す行。
            timeChangedWithoutRest:
              (changedStart || changedEnd) &&
              !Object.prototype.hasOwnProperty.call(values, 'rest'),
            // ファイルに休憩が書いていない行で、プロジェクトが変わった。
            // 画面でプロジェクトを変えたときと同じく、休憩を計算し直す行。
            projectChangedWithoutRest:
              changedProject &&
              !Object.prototype.hasOwnProperty.call(values, 'rest'),
            // ファイルに休憩が書いていない行で、夜勤休憩が変わった。
            // 画面で夜勤休憩の欄を変えたときと同じ扱いをする行（計算するのは、勤怠がシフトの日だけ）。
            nightRestChangedWithoutRest:
              changedNightRest &&
              !Object.prototype.hasOwnProperty.call(values, 'rest')
          });
        }
      });

      /*
       * 休憩の自動計算を呼ぶ行（取り込みの小窓の、休憩を補完するチェックを入れたときだけ）。
       *
       * 1. 休憩が空の行（今までどおり）。
       * 2. ファイルに休憩が書いていなくて、取り込みで開始か終了が変わった行。
       *    休憩が入っている行でも呼ぶ。出勤だけ打刻した日（打刻が休憩を入れている）へ、
       *    取り込みで終了を入れたとき、時刻欄で終了を入れたときと同じ休憩にするため。
       * 3. ファイルに休憩が書いていなくて、取り込みでプロジェクトが変わった行。
       *    プロジェクトごとに休憩と定時が違う。画面でプロジェクトを変えたとき（onChangeProject）と
       *    同じ休憩にするため。呼ぶ前に、新しいプロジェクトの基準を取り終えている（下の projectChanged）。
       *
       * 4. ファイルに休憩が書いていなくて、取り込みで夜勤休憩だけが変わった行。
       *    画面で夜勤休憩の欄を変えたとき（onNightRestChange）と同じ扱いにする。計算するのは、
       *    勤怠がシフトの日だけ（休憩の式が夜勤休憩を見るのは、シフトの日だけ）。
       *    勤怠は、この取り込みで変わったあとの値で見る。
       *
       * 呼ぶのは、時刻欄の変更・プロジェクトの変更と同じ autoRestTime。手で直した休憩は、
       * 画面の包み（Roster.js）が上書きしない。
       *
       * ファイルに休憩が書いてある行は、呼ばない（その値を入れる。入力済みで入らなかったときも呼ばない）。
       *
       * 勤怠1の選択欄を変えたときの処理（autoTime。シフトなら勤怠2もシフトに、時刻を持たない区分なら
       * 時刻の欄を空に）は、この取り込みで勤怠1が実際に変わった行だけで呼ぶ。勤務表でも、勤怠1の欄を
       * 変えたときにしか呼ばれない。以前は触った行すべてで呼んでいて、休日に出勤した日（勤怠1＝休日）へ
       * 時刻を取り込むと、勤怠を変えていないのに、開始・終了・休憩・夜勤休憩が全部空になっていた（2026-10-03）。
       * ファイルの勤怠が時刻を持たない区分のときに時刻を空にするのは、取り込みの側（utils/rosterImport.js）。
       *
       * 勤怠2だけが変わった行では呼ばない。勤務表の勤怠2の選択欄には、変更時の処理が無い（2026-10-03）。
       * 以前は、取り込みの側がシフトの行の勤怠2を空欄として渡していた（シフトを「勤怠2を使わない区分」と
       * 取り違えていた）ので、それをシフトへ戻すために、勤怠2だけが変わった行でも呼んでいた。
       * 取り違えは直した（勤怠2を使う区分の並びは utils/rosterActualPolicy.js の usesAttendance2。
       * 勤務表の computed の afternoon と同じ並び）。
       *
       * 開始か終了がこの取り込みで変わった行は、時刻欄を変えたときと同じく、打刻が入れた夜勤休憩 00:00 を
       * 空へ戻す（clearUnstampedNightRestAt。勤務表の時刻欄の変更 autoRestTime が通るのと同じ処理）。
       * ファイルに休憩が書いてある行でも、休憩の補完を外した取り込みでも戻す。休憩の補完を外した選択は
       * 「休憩を計算し直さない」という意味で、打刻が入れた夜勤休憩の後始末とは別のため。
       */
      const finalize = () => {
        touchedRows.forEach(row => {
          if (row.attendanceChanged) this.autoTime(row.index);
          if (row.timeChanged) this.clearUnstampedNightRestAt(row.index);
          if (
            fillRestFromSchedule &&
            this.start[row.index] &&
            this.end[row.index] &&
            (
              (row.autoFillRest && !this.rest[row.index]) ||
              row.timeChangedWithoutRest ||
              row.projectChangedWithoutRest
            )
          ) {
            this.autoRestTime(row.index);
          } else if (fillRestFromSchedule && row.nightRestChangedWithoutRest) {
            // 夜勤休憩の欄を変えたときと同じ入口（シフトの日で、開始と終了がある行だけ計算する）。
            this.onNightRestChange(row.index);
          }
        });
        this.$nextTick(() => this.$forceUpdate());
      };

      if (projectChanged) {
        // 新しいプロジェクトの設定を待っているあいだは、読み込み中と同じ幕を出す（basicsWaiting）。
        // 待たずに［保存］を押すと、前のプロジェクトの休憩のまま保存されていた。
        // 待つあいだに表を読み直したら（listRequestSeq が進んだら）、前の表の続き（finalize）は流さない。
        const listSeq = this.listRequestSeq;
        this.basicsWaiting += 1;
        this.hydrateDailyBasicsByProject()
          .then(() => {
            if (listSeq !== this.listRequestSeq) return;
            finalize();
          })
          .catch(() => {
            this.notify('プロジェクト設定を取得できませんでした。画面を再読み込みしてから、もう一度取り込んでください。');
          })
          .finally(() => {
            // 成功でも失敗でも必ず戻す（幕が残って固まらない）。
            this.basicsWaiting = Math.max(0, this.basicsWaiting - 1);
          });
      } else {
        finalize();
      }
    },
    autoFillDefaultTimes(i) {
      return this.applyDefaultAt(i);
    },
    formatDurationToHHMM(duration) {
      const hours = Math.abs(duration.hours()) < 10 ? "0" + Math.abs(duration.hours()) : Math.abs(duration.hours());
      const minutes = Math.abs(duration.minutes()) < 10 ? "0" + Math.abs(duration.minutes()) : Math.abs(duration.minutes());
      return (duration.asMinutes() < 0 ? "-" : "") + hours + ":" + minutes;
    },
    // 表示用のラベル変換
    getStatusLabel(status) {
      if (!status) {
        return ConstList.UNSUBMITTED; // '未申請'
      }
      return status;
    },
    // 承認状態の識別
    statusColor(status) {
      const label = this.getStatusLabel(status);
      switch (label) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED:
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    // プロジェクトID配列から日別の基準を流し込む（Promise版）
    //
    // 応答は、いちばん新しく頼んだ1本だけ採る。頼んだあとに表を読み直したとき（listRequestSeq が進んだ）と、
    // この取得をもう一度頼んだとき（basicsRequestSeq が進んだ）は、遅れて返った応答を基準に書かずに捨てる。
    // 捨てないと、前の表の設定待ちのあいだに読み直した表の基準が、古い案件の設定で上書きされ、そのあとの
    // 休憩の計算と保存が古い設定のままになっていた（2026-10-03 の監査 WAIT-1）。捨てたときは基準の配列を
    // 差し替えないので、呼び出し元は「取得できなかった」と同じに扱う。
    hydrateDailyBasicsByProject() {
      const ids = Array.from(new Set(this.projectId.filter(v => v != null)));
      if (!ids.length) return Promise.resolve(); // 呼び出し元のthenチェーンを壊さない

      this.basicsRequestSeq = (this.basicsRequestSeq || 0) + 1;
      const basicsSeq = this.basicsRequestSeq;
      const listSeq = this.listRequestSeq;
      const isLatest = () => basicsSeq === this.basicsRequestSeq && listSeq === this.listRequestSeq;

      return axios
        .get(process.env.VUE_APP_API_ORIGIN + "/project-basics", {
          params: { ids: ids.join(",") }
        })
        .then(({ data }) => {
          if (!isLatest()) return;
          // 例：data = { "101": {...}, "102": {...} }
          this.projectId.forEach((pid, i) => {
            const p = data[String(pid)];
            if (!p) return;
            this.$set(this.startBasic, i, p.start ?? "");
            this.$set(this.endBasic,   i, p.end ?? "");
            this.$set(this.breakBasic, i, p.break ?? "");
            this.$set(this.breakStartBasic, i, p.breakStart ?? "");
            this.$set(this.breakEndBasic,   i, p.breakEnd ?? "");
            this.$set(this.preBuffer,  i, p.preBuffer ?? "00:00");
            this.$set(this.postBuffer, i, p.postBuffer ?? "00:00");
            this.$set(this.workTimeUnit, i, p.workTimeUnit ?? "00:00");
            this.$set(this.workBasic,    i, p.workBasic ?? "00:00");
            this.$set(this.postWorkBreakFlg, i, !!p.postWorkBreakFlg);
          });
          // 参照替えで子コンポーネント再計算
          this.startBasic = [...this.startBasic];
          this.endBasic   = [...this.endBasic];
          this.breakBasic = [...this.breakBasic];
          this.breakStartBasic = [...this.breakStartBasic];
          this.breakEndBasic = [...this.breakEndBasic];
          this.preBuffer  = [...this.preBuffer];
          this.postBuffer = [...this.postBuffer];
          this.workTimeUnit = [...this.workTimeUnit];
          this.workBasic    = [...this.workBasic];
          this.postWorkBreakFlg = [...this.postWorkBreakFlg];
        })
        .catch((e) => {
          axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(e) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => this.notify(requestFailureMessage(e)))
            .catch(() => this.notify(requestFailureMessage(e, ConstList.SYSTEM_COMMUNICATION_ERROR)));
        });
    },

    /*
     * 行のプロジェクトが変わり、その行の案件の設定（定時・休憩・猶予）が入ったあとに流す休憩の計算。
     *
     * 行のプロジェクトの選ぶ欄（onChangeProject）と、表の見出しの一括変更（applyBulkProject）が、
     * この同じ1つを呼ぶ。一括変更は休憩を計算し直していなかったので、同じ日・同じ時刻・同じ案件でも、
     * 一括なら 01:30、行ごとなら 01:20 と入口で休憩が分かれ、一括のあと保存して開き直すと
     * 「手で直した休憩」として固定されていた（2026-10-02 に画面で確かめた）。
     *
     * 手で直した休憩（isRestManual）は、案件を変えても計算し直さない。開始と終了がそろった行は、
     * 包み（Roster.js の autoRestTime）も上書きしないが、終了がまだ無い行は、autoRestTime の最初の分岐
     * （時刻を消したときに休憩を残さない決まり）が固定を外して休憩を空にする。案件を変えただけで、
     * 出勤のあと勤務表で直して保存した休憩が消えて保存されていた（行ごとの変更は前から。一括へ同じ処理を
     * 流したことで一括にも広がった。2026-10-03 の反証で見つけた）。
     */
    restAfterProjectChange(index) {
      if (this.isRestManual(index)) return;
      this.autoRestTime(index);
    },

    // プロジェクト選択変更時（Promise版）
    //
    // 案件の設定を待っているあいだは、読み込み中と同じ幕を出す（basicsWaiting）。待たずに［保存］や
    // 行の［定時を反映］を押すと、新しいプロジェクトに前のプロジェクトの休憩・定時のまま入っていた。
    // 応答は、その行で最後に頼んだ1本だけ採る（続けて変えて、応答が逆の順で返っても、最後に選んだ
    // プロジェクトで決める）。待つあいだに表を読み直したら、前の表で頼んだ応答は捨てる。
    onChangeProject(index) {
      const pid = this.projectId[index];
      if (pid == null) return;

      const listSeq = this.listRequestSeq;
      const rowSeqs = this.projectRequestSeq || (this.projectRequestSeq = {});
      const rowSeq = (rowSeqs[index] || 0) + 1;
      rowSeqs[index] = rowSeq;
      const isLatest = () => listSeq === this.listRequestSeq && rowSeq === rowSeqs[index];
      this.basicsWaiting += 1;

      return axios
        .get(process.env.VUE_APP_API_ORIGIN + "/project-basic", {
          params: { projectId: pid }
        })
        .then(({ data: p }) => {
          if (!isLatest()) return;
          this.$set(this.startBasic, index, p.start ?? "");
          this.$set(this.endBasic,   index, p.end ?? "");
          this.$set(this.breakBasic, index, p.break ?? "");
          this.$set(this.breakStartBasic, index, p.breakStart ?? "");
          this.$set(this.breakEndBasic,   index, p.breakEnd ?? "");
          this.$set(this.preBuffer,  index, p.preBuffer ?? "00:00");
          this.$set(this.postBuffer, index, p.postBuffer ?? "00:00");
          this.$set(this.workTimeUnit, index, p.workTimeUnit ?? "00:00");
          this.$set(this.workBasic,    index, p.workBasic ?? "00:00");
          this.$set(this.postWorkBreakFlg, index, !!p.postWorkBreakFlg);

          // 直ちに休憩再計算（postWorkBreakFlg / endBasic の影響を反映）
          this.restAfterProjectChange(index);

          // 参照替えで子を再計算
          this.startBasic = [...this.startBasic];
          this.endBasic   = [...this.endBasic];
          this.breakBasic = [...this.breakBasic];
          this.breakStartBasic = [...this.breakStartBasic];
          this.breakEndBasic = [...this.breakEndBasic];
          this.preBuffer  = [...this.preBuffer];
          this.postBuffer = [...this.postBuffer];
          this.workTimeUnit = [...this.workTimeUnit];
          this.workBasic    = [...this.workBasic];
          this.postWorkBreakFlg = [...this.postWorkBreakFlg];
        })
        .catch((e) => {
          if (!isLatest()) return;
          axios
            .post(`${process.env.VUE_APP_API_ORIGIN}/error/frontError`, { error: String(e) }, { headers: { 'Content-Type': 'application/json' } })
            .then(() => this.notify(requestFailureMessage(e)))
            .catch(() => this.notify(requestFailureMessage(e, ConstList.SYSTEM_COMMUNICATION_ERROR)));
        })
        .finally(() => {
          // 成功でも失敗でも必ず戻す（幕が残って固まらない）。
          this.basicsWaiting = Math.max(0, this.basicsWaiting - 1);
        });
    },
    applyBulkProject() {
      if (!this.bulkProjectId) return; // 空は処理しない

      this.bulkApplying = true;
      const pid = this.bulkProjectId;
      // プロジェクトが実際に変わる行（行ごとの選ぶ欄でも、変わった行でしか計算しない）。
      const changedRows = this.projectId
        .map((before, index) => (before === pid ? null : index))
        .filter(index => index !== null);
      this.projectId = this.projectId.map(() => pid);
      const listSeq = this.listRequestSeq;
      // 設定の取得に成功したときだけ、基準の配列が新しいものへ差し替わる（hydrateDailyBasicsByProject）。
      const basicsBefore = this.startBasic;

      const done = () => {
        this.bulkApplying = false;
        this.bulkProjectId = "";
      };
      // 行ごとに変えたときと同じ休憩の計算を、変わった行へ流す（restAfterProjectChange）。
      // 取得に失敗したときは流さない（行ごとの変更も、失敗したら計算しない）。
      const recalculate = () => {
        if (listSeq !== this.listRequestSeq || this.startBasic === basicsBefore) return;
        changedRows.forEach(index => this.restAfterProjectChange(index));
      };

      if (this.hydrateDailyBasicsByProject) {
        const r = this.hydrateDailyBasicsByProject();
        if (r && typeof r.then === "function") {
          r.then(recalculate).then(done).catch(done);
        } else {
          done();
        }
      } else {
        done();
      }
    },
    // 保存の送り始めと終わり（成功・失敗のどちらでも）。送信中も、読み込み中と同じ幕を出す。
    onSavingChange(value) {
      this.saving = Boolean(value);
    },
    openAttendanceHelp(kind) {
      this.attendanceHelpKind = kind;
      this.attendanceHelpOpen = true;
    },
    openAttendance1Help() { this.openAttendanceHelp("1"); },
    openAttendance2Help() { this.openAttendanceHelp("2"); },
    closeAttendanceHelp() {
  this.attendanceHelpOpen = false;
},

  },
  computed: {
    // ［保存］が押せない理由（承認待ち・承認済み）。上に出している文と同じもの。
    lockReason() {
      return submissionLockReason(this.statusBtn, this.errors);
    },
    /*
     * 保存できない勤務表か。管理者用（勤務表一覧 → 社員名）と、承認待ち・承認済みの月。
     *
     * **保存できないのに書き換えられる画面にしない。**前は［保存］と取込・一括の定時反映
     * だけを止め、時刻・勤怠・プロジェクト・一括変更・行ごとの「定時を反映」は押せた。
     * 書き換えても画面を離れると元に戻る（2026-09-30 の洗い出し）。
     */
    readOnly() {
      return this.fromExternal || this.statusBtn;
    },
    // 勤務時間の自動計算
    dailyWorkResult() {
      const result = [];
      for (let i = 0; i < this.start.length; i++) {
        const s = moment.duration(this.start[i], "HH:mm");
        const e = moment.duration(this.end[i], "HH:mm");
        const restDuration = moment.duration(this.rest[i] || "00:00", "HH:mm");
        const nightRestDuration = moment.duration(this.nightRest?.[i] ?? "00:00", "HH:mm");

        let actualStart = s.clone();
        const startBasicTime = moment.duration(this.startBasic[i], "HH:mm");

        // 入力が揃っていない日は null
        if (!this.start[i] || !this.end[i]) {
          result.push(null);
          continue;
        }

        // 日をまたぐか（終了が翌日か）は、入力したままの開始と終了を分で比べて決める（終了 ≦ 開始なら翌日）。
        // **開始を定時へ寄せる前に決める。**寄せたあとで比べると、定時の開始までに退勤した日
        // （08:40〜08:55）を翌日までの勤務と見て、勤務 22:55・時間外 14:55 を出していた。
        const nextDayEnd = endsOnNextDay(s.asMinutes(), e.asMinutes());

        // 始業時刻補正（遅刻除外）
        if (
          this.attendance1[i] === ConstList.FULLTIME ||
          this.attendance1[i] === ConstList.MORNING_WORK
        ) {
          const preBuffer = moment.duration(this.preBuffer[i] ?? "00:00", "HH:mm");
          const preBufferStart = startBasicTime.clone().subtract(preBuffer);

          if (
            actualStart.asMinutes() >= preBufferStart.asMinutes() &&
            actualStart.asMinutes() < startBasicTime.asMinutes()
          ) {
            actualStart = startBasicTime;
          }
        }

        // 終了時刻の補正（00:00 の場合は翌日扱い）
        let actualEnd = e.clone();
        if (nextDayEnd) {
          actualEnd = actualEnd.add(24, "hours");
        } else if (actualEnd.asMinutes() < actualStart.asMinutes()) {
          // 定時の開始までに退勤した日。開始を定時へ寄せたので、働いた時間は 0 として扱う（翌日扱いにしない）。
          actualEnd = actualStart.clone();
        }

        // 勤務時間計算
        let workDuration = actualEnd.clone().subtract(actualStart).subtract(restDuration).subtract(nightRestDuration);

        result.push(this.formatDurationToHHMM(workDuration));
      }

      return [...result];
    },

    // 勤怠の入力制御
    // 勤怠2を使う区分（午前系・早出・シフト）の並びは utils/rosterActualPolicy.js の1か所。
    // ファイル取り込みの確認（utils/rosterImport.js の「勤怠2を使用しない」の判定）も、同じ並びを見る。
    // 入力手順と勤怠1・勤怠2の説明に並べる名前（rosterAttendanceKinds.js）も、同じ並びから作る。
    afternoon: function () {
      const afternoon = this.devide;
      const list = this.attendance2;
      for (let i = 0; i < this.attendance1.length; i++) {
        if (usesAttendance2(this.attendance1[i])) {
          afternoon.splice(i, 1, false);
        } else {
          list.splice(i, 1, "");
          afternoon.splice(i, 1, true);
        }
      }
      return afternoon;
    },
    /*
     * 半日単位の休暇を使うか。**行ごとに同じ値が載ってくる**ので
     * 先頭を見る。読めないときは「使う」——いま使っている会社の
     * 選択肢を、通信の失敗で黙って消さない。
     */
    usesHalfDayLeave: function () {
      const row = this.items && this.items.length ? this.items[0] : null;
      return !row || row.half_day_leave_flg !== false;
    },
    // 送信用の開始時間の配列作成
    sendStart: function () {
      let sendS = this.start_time;
      for (let i = 0; i < this.start.length; i++) {
        const sTime = this.start[i] || "09:00";
        sendS.splice(i, 1, sTime + ":00");
      }
      return sendS;
    },
    // 送信用の終了時間の配列作成
    sendEnd: function () {
      let sendE = this.end_time;
      for (let i = 0; i < this.end.length; i++) {
        const eTime = this.end[i] || "18:00";
        sendE.splice(i, 1, eTime + ":00");
      }
      return sendE;
    },
    // 送信用の休憩時間の配列作成
    sendBreak: function () {
      let sendB = this.break_time;
      for (let i = 0; i < this.rest.length; i++) {
        const bTime = this.rest[i] || "01:00";
        sendB.splice(i, 1, bTime + ":00");
      }
      return sendB;
    },
    // 登録・更新ボタンの活性非活性
    activeButton: function () {
      const start = this.start;
      const end = this.end;
      const rest = this.rest;
      const id1 = this.attendance1;
      const remarks = this.remarks;
      if (
        start[0] !== "" &&
        end[0] !== "" &&
        rest[0] !== "" &&
        id1[0] !== 0 &&
        remarks[0] !== ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    // 終了時刻が0時を過ぎた場合の数値調整
    endSetting: function () {
      let setting = this.send_end;
      for (let i = 0; i < this.end.length; i++) {
        if (this.end[i] === "" || this.end[i] === null) {
          // null または空文字の場合に null を代入する
          setting.splice(i, 1, null);
        } else {
          let start = moment.duration(this.start[i], "HH:mm");
          let end = moment.duration(this.end[i], "HH:mm");
          let hour = 0;
          let minute = 0;
          // 日をまたぐか（終了が翌日か）は、勤務時間の計算・夜勤と同じ判定で決める（分で比べる）。
          // 以前は「時」だけで比べていたので、同じ時台で終了のほうが前の勤務（22:30〜翌22:10）に 24 を足していなかった。
          // 開始と終了が同じ行は、今までどおり足さない
          // （開始と終了が同じ日は、保存のときに「開始時刻と終了時刻が同じです」と断られる。足すと別の文になる）。
          if (
            end.asMinutes() !== start.asMinutes() &&
            endsOnNextDay(start.asMinutes(), end.asMinutes())
          ) {
            hour = end.hours() + 24;
            minute = end.minutes();
            const hours = hour < 10 ? "0" + hour : hour;
            const minutes = minute < 10 ? "0" + minute : minute;
            const time = hours + ":" + minutes;
            setting.splice(i, 1, time);
          } else {
            const hours = end.hours() < 10 ? "0" + end.hours() : end.hours();
            const minutes =
              end.minutes() < 10 ? "0" + end.minutes() : end.minutes();
            const time = hours + ":" + minutes;
            setting.splice(i, 1, time);
          }
        }
      }
      return 0;
    },
    /*
     * 幕（画面全体のくるくる）を出すか。**入力と操作を止める条件も、この1本だけを見る。**
     *
     * 読み込み中・一括変更の待ち・案件の設定の待ち（行のプロジェクトの変更・取り込みの反映）・保存の送信中。
     * 幕はマウスを止めるが、欄そのものは止まっていなかったので、キーボードで入れた値が消えたり、
     * 読み込みの途中の値で休憩が「手で直した休憩」として固定されたりした。止める所（表の欄・
     * 行とまとめの［定時を反映］・取り込みの小窓・一括の選ぶ欄・［表示］・［保存］）が、それぞれ
     * 別の条件を見ていたので、待ちの種類によっては押せた。
     */
    globalLoading() {
      return this.loading || this.bulkApplying || this.basicsWaiting > 0 || this.saving;
    },
    // 取り込みの小窓へ渡す、行ごとの「休憩を空欄と同じに扱うか」。
    // 取り込みの確認の表と、勤務表へ入れる所（applyRosterFileImport）が、同じ答えを使う。
    importRestAsBlank() {
      return this.monthDay.map((_, index) => this.restCountsAsBlankForImport(index) === true);
    },
    // 同じく、行ごとの「夜勤休憩を空欄と同じに扱うか」。
    importNightRestAsBlank() {
      return this.monthDay.map((_, index) => this.nightRestCountsAsBlankForImport(index) === true);
    },
  },
  mounted() {
    if (this.fromExternal) {
      // 管理者が対象ユーザーを表示する場合（Info.vue 経由）
      this.user_id = this.externalUserId;
      this.year = this.externalYear;
      this.month = this.externalMonth;
      this.user_name = this.externalUserName;
      this.callList(); // ← 外から渡されたユーザで初回表示
    } else {
      // 一般ユーザーの場合（ログインユーザー自身）
      const today = moment();
      if (today.date() < 10) {
        today.subtract(1, "months");
      }
      // ダッシュボードの「月次提出状況」の行から開いたときは、その行の月で開く
      // （URL に年月が付いてくる）。左メニューから開いたときは今までどおり。
      const asked = askedYearMonth(this.$route);
      this.year = asked ? asked.year : Number(today.format("YYYY"));
      this.month = asked ? asked.month : Number(today.format("M"));
      const context = getCachedAccessContext();
      this.user_id = context && context.userId ? context.userId : "";
      this.user_name = "";
    }
    this.startRosterHScroll();
  },
  updated() {
    // 行の数・列の幅は、読み込み・取り込み・入力で変わる。表が作り直されていれば見張りを付け替え、
    // 張り付いた横スクロールバーの長さを表の幅へ合わせる。
    this.watchRosterTable();
  },
  beforeDestroy() {
    if (this.rosterResizeObserver) this.rosterResizeObserver.disconnect();
    this.rosterResizeObserver = null;
    this.rosterWatchedTable = null;
    window.removeEventListener("resize", this.measureRosterScroll);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/*
  検索パネルの枠を、中身の幅に合わせる。

  **共通側（workflow.css）は触らない。**あちらは9画面で使っていて、
  条件が多い画面では全幅が正しい。この画面だけ条件が「年月」しか
  ないので、全幅だと右3分の2が空の罫線になる。

  クラスを2つ重ねているのは詳細度のため。共通側は
  `.preika-route-view--business .search-table` に !important 付きで
  当たっているので、同じ強さだと**読み込まれた順で勝ち負けが変わる。**
*/
.search-table.roster-search-table {
  width: auto !important;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}

button:disabled {
  cursor: not-allowed;
}

.dayHeader { white-space: pre; }  /* <br> だけで改行。自動折返しなし */
.dayLabel  { white-space: pre; }  /* \n だけで改行。自動折返しなし */

.roster-guide-grid {
  display: grid;
  margin: 0 25px 24px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 20px;
}

.roster-guide-grid > .roster-guide-card,
.roster-guide-grid > .roster-guide-card + .roster-guide-card {
  display: flex;
  width: 100%;
  min-width: 0;
  min-height: 300px;
  flex-direction: column;
  margin: 0 !important;
  overflow: hidden;
}

.roster-guide-card__header {
  display: flex !important;
  min-height: 76px !important;
  align-items: center !important;
  padding: 20px 28px !important;
  border-bottom: 1px solid rgba(255, 255, 255, .18) !important;
  background: rgba(255, 255, 255, .08) !important;
  color: inherit !important;
  gap: 12px;
}

.roster-guide-card__header::before,
.roster-guide-card__header::after {
  content: none !important;
}

.roster-guide-card__header strong {
  color: inherit !important;
  font-size: 20px !important;
  font-weight: 800 !important;
}

.roster-guide-card__badge {
  margin-left: auto;
  font-size: 12px;
  white-space: nowrap;
}

/*
  入力手順の欄（青緑の背景・白い字）の「勤怠1の説明／勤怠2の説明」。全体のリンクの色（濃い青）のままだと
  背景に沈んで読めなかったので、この欄の中だけ白い字・白の下線にする（ほかの画面のリンクは変えない）。
*/
.roster-guide-card.text-white .roster-guide-card__body a.paid-rule-link {
  /* 業務画面のリンクの決まり（.preika-route-view--business a:not(...)）より強く当てる。 */
  color: #fff;
  text-decoration-color: rgba(255, 255, 255, .7);
}

.roster-guide-card__body {
  flex: 1 1 auto;
  padding: 24px 28px !important;
  color: inherit;
  font-size: 15px;
  line-height: 1.85;
}

.roster-guide-file {
  display: block;
  width: min(100%, 320px);
  min-width: 0;
}

.roster-actual-guide {
  /*
    **縦に積む。**以前は space-between で右端へ飛ばしていた。
    画面が広いほど説明から離れ、読み終わった視線の先に無い。
  */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 16px;
  padding: 14px 16px;
  border: 1px solid #cfe2f2;
  border-radius: 12px;
  background: #f5faff;
}
.roster-actual-guide strong { color: #164e75; }
.roster-actual-guide p { margin: 0; color: #60788a; font-size: 12px; }
/* **押すものだと分かる色にする。**枠だけだと周りの白い枠に紛れる。
   誤って押しても、applyDefaultsToPast が確認の幕を出して止まる。 */
/* **左端を見出しへ揃える。**素の button に margin: 1em が当たっていて、
   縦に積んだ瞬間に 11px ずれた。右端に置いていたときは目立たなかった。 */
.roster-actual-guide__action { flex: 0 0 auto; margin: 0; }
/*
  **中身が無くても1行ぶんの高さを持つ。**候補は入力すると消えるので、
  高さまで消えると入力した欄だけ縮んで行の中でずれる。候補を出さない列
  （休憩）とも揃わない。テスターの指摘はこれ（2026-09-09）。
  RestInput の .roster-auto-rest-note と同じ決まり（高さ・行の高さ 16px・折り返さない）にそろえてある。
  高さを決めておけば、注記の中身で入力欄の位置が変わらない（監査 FF-1）。
*/
.roster-time-candidate {
  display: block;
  margin-top: -1px;
  height: 16px;
  min-height: 16px;
  color: #70899a;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
}

/*
  入力の誤りを、欄のすぐ下に出す。

  **上にまとめて出さない。**31行ある表で「どこかが赤い」とだけ
  言われても探せない。前の RosterError がその形で、しかも中身が
  全部コメントアウトされていて1行も出なかった。
*/
.roster-field-error {
  display: block;
  margin: 1px 0 0;
  color: #c0392b;
  font-size: 12px;
  line-height: 1.3;
  white-space: nowrap;
}
.roster-row-state {
  display: block;
  margin-top: 5px;
  color: #7f91a0;
  font-size: 12px;
  font-weight: 700;
}
/* 入力区分の印。色だけに頼らない（形と、横の文字でも分かる）。 */
.roster-stamp-button {
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 5px;
  padding: 1px 4px;
  border: 1px solid var(--preika-blue-500);
  border-radius: 7px;
  background: #fff;
  color: #12679e;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.roster-stamp-button:hover,
.roster-stamp-button:focus {
  background: #eaf4fb;
}
.roster-stamp-mark {
  display: inline-block;
  width: 12px;
  height: 12px;
  flex: none;
  box-sizing: border-box;
}
/* 打刻：丸（時計の形） */
.roster-stamp-mark--STAMP {
  border: 2px solid #2e7d5b;
  border-radius: 50%;
  background: #fff;
}
/* 打刻後修正：丸の半分を塗る */
.roster-stamp-mark--EDITED {
  border: 2px solid #b26a00;
  border-radius: 50%;
  background: linear-gradient(90deg, #b26a00 50%, #fff 50%);
}
/* 手入力：四角を塗る */
.roster-stamp-mark--ROSTER {
  border: 2px solid #b26a00;
  border-radius: 2px;
  background: #b26a00;
}
/* 勤務表で入力・修正した時刻の枠。土曜・休日の行の色より濃くして、行の色に埋もれさせない。 */
/* 行の色の決まり（#roster tbody.blue > tr > td。style.scss）より強く当てる。 */
#roster tbody > tr > td.roster-cell--by-roster,
#roster tbody.blue > tr > td.roster-cell--by-roster,
#roster tbody.red > tr > td.roster-cell--by-roster {
  background-color: #e9b949 !important;
}
.roster-stamp-legend {
  margin: 0 0 8px;
  color: #33475b;
  font-size: 12px;
}
.roster-stamp-legend ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 14px;
  margin: 0 0 2px;
  padding: 0;
  list-style: none;
}
.roster-stamp-legend li {
  display: flex;
  align-items: center;
  gap: 4px;
}
.roster-stamp-legend small {
  display: block;
  color: #5c6f80;
}
.roster-stamp-summary {
  margin: 0 0 6px;
  font-weight: 700;
}
.roster-stamp-summary--entered {
  display: inline-block;
  padding: 3px 8px;
  border-left: 4px solid #b26a00;
  background: #fbefd0;
}
.roster-stamp-history-row > td {
  background: #f5f8fa;
}
.roster-stamp-history {
  text-align: left;
  font-size: 12px;
}
.roster-stamp-history table {
  margin-top: 4px;
  border-collapse: collapse;
}
.roster-stamp-history th,
.roster-stamp-history td {
  padding: 3px 12px 3px 0;
  border: 0;
  background: transparent;
  white-space: nowrap;
}
.roster-stamp-history__gap {
  color: #c0392b;
  font-weight: 700;
}
.roster-default-button {
  margin-top: 5px;
  padding: 3px 6px;
  /* 白地に溶けない濃さへ。枠線だけの青ボタンと同じ扱いにそろえる。 */
  border: 1px solid var(--preika-blue-500);
  border-radius: 7px;
  background: #fff;
  color: #12679e;
  font-size: 12px;
  font-weight: 700;
}
@media (max-width: 991.98px) {
  .roster-guide-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 767.98px) {
  .roster-guide-grid {
    margin-right: 14px;
    margin-left: 14px;
  }

  /* 狭い画面では横いっぱいに。並び自体は既に縦。 */
  .roster-actual-guide__action { width: 100%; }
}

/*
  画面の下端に張り付く横スクロールバー（2026-10-03 の要望）。表の箱の横スクロールバーは隠し、
  このバーと横位置をそろえる。表のすぐ下に置くので、一番下まで送るとそこに収まる。
*/
/*
  カードの overflow: hidden（components.css の「#roster > .card」）は張り付きを止める（カードが張り付きの
  箱になり、画面の下端まで来ない）。角の丸めは残す clip にする。id を含めないと、あちらの id の強さに負ける。
*/
#roster > .roster-card {
  overflow: clip;
}
.roster-table-scroll {
  scrollbar-width: none;
}
.roster-table-scroll::-webkit-scrollbar {
  height: 0;
}
.roster-hscroll {
  position: sticky;
  bottom: 0;
  z-index: 3;
  flex: 0 0 100%;
  max-width: 100%;
  height: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  background: #fff;
}
.roster-hscroll__track {
  height: 1px;
}
@media print {
  .roster-hscroll { display: none; }
}

</style>
